// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:03:22.516Z
// Property: 46 Penn Apartment Homes (ID: 6767906449167587)
// Collections: 37 amenities, 11 floorplans (live), 41 photos, 70 POIs, 4 reviews, 10 virtual tours, 6 office hours, 16 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167587",
  "property_external_id": "1124013",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/46-penn-apartment-homes-kansas-city-mo/vf0syce/",
  "property_google_business_url": "https://www.google.com/maps/place/46+Penn+Apartment+Homes/@39.0443417,-94.5931512,1777m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0efc61f6d6933:0xe69191c42199195b!8m2!3d39.0443417!4d-94.5931512!16s%2Fg%2F11b8t7df0n?entry=ttu&g_ep=EgoyMDI2MDgxMi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124013\tp1098965",
  "property_status": null,
  "property_slug": "46-penn-apartment-homes",
  "property_name": "46 Penn Apartment Homes",
  "property_website_url": "https://www.46penn.com/",
  "property_domain": "https://www.46penn.com/",
  "property_address": "4551 Pennsylvania Ave",
  "property_full_address": "4551 Pennsylvania Ave, Kansas City, MO 64111",
  "property_address_1": "4551 Pennsylvania Ave",
  "property_address_2": null,
  "property_address_city": "Kansas City",
  "property_address_state": "MO",
  "property_address_zip_full": null,
  "property_address_zip": "64111",
  "property_address_country": "US",
  "property_address_county": "Jackson County",
  "property_neighborhood_address": "Midtown - Westport",
  "property_address_latitude": "39.0448299",
  "property_address_longitude": "-94.59291619999999",
  "property_email": "rentcafe.46p@pricekc.com",
  "property_phone": "(816) 323-5269",
  "property_call_tracking_phone": "816-323-5269",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Plaza-side comfort with Midtown momentum.</strong> Discover spacious one- and two-bedroom apartments with polished finishes, connected conveniences, and resort-style spaces—then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience 46 Penn Apartment Homes in person.</p>",
  "property_long_description": "Embrace luxury living with a resort-style twist in a community that offers a seemingly endless list of amenities. 46 Penn Apartments is a great place to start a brand-new chapter, whether you're looking for a cozy one-bedroom home or a larger, two-bedroom residence. These luxury apartments in Country Club Plaza, Kansas City, have everything you need to work, play, and thrive, including a business center, state-of-the-art fitness center, and quiet nesting areas with water features.Our location crowns your experience - you'll live in a prestigious neighborhood just one block from the historic Country Club Plaza, with an impressive 85 walk score and close to Kansas City University and the Kansas City Zoo. Our homes appeal to luxury lovers, passionate cooks, and everyone in between. They feature all the things you'd expect from modern living, such as hardwood floors, recessed lighting, stainless steel appliances, large showers, and French doors that open to balconies.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0d4bc-209e-7296-a871-7f9c752ea3e2.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of a modern apartment building at dusk with a pink sky.",
    "public_id": "01a0d4bc-209e-7296-a871-7f9c752ea3e2",
    "storage_key": "property/6767906449167587/01a0d4bc-209e-7296-a871-7f9c752ea3e2.webp",
    "width": 1920,
    "height": 1409
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "169",
  "property_year_built": "2015",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.0828402366864",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-275",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restricted Breeds: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.  Application Requirements: Before we can approve your application, you m",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://46penn.securecafeapplicant.com/onlineleasing/content3/access/46-penn1/floorplans",
  "property_resident_portal_url": "https://46penn.securecafe.com/residentservices/46-penn1/userlogin.aspx",
  "property_apply_now_url": "https://46penn.securecafeapplicant.com/onlineleasing/content3/access/46-penn1/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91e-7a0e-765d-84f8-3ca32cda7c62.webp",
  "property_primary_logo_media": {
    "alt_text": "Logo for 46 Penn Apartments",
    "public_id": "019fc91e-7a0e-765d-84f8-3ca32cda7c62",
    "storage_key": "property/6767906449167587/019fc91e-7a0e-765d-84f8-3ca32cda7c62.webp",
    "width": 377,
    "height": 515
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91f-58d0-74be-a75d-e357c0513810.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc91f-58d0-74be-a75d-e357c0513810",
    "storage_key": "property/6767906449167587/019fc91f-58d0-74be-a75d-e357c0513810.webp",
    "width": 377,
    "height": 515
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91e-7a0e-765d-84f8-3ca32cda7c62.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Logo for 46 Penn Apartments",
    "public_id": "019fc91e-7a0e-765d-84f8-3ca32cda7c62",
    "storage_key": "property/6767906449167587/019fc91e-7a0e-765d-84f8-3ca32cda7c62.webp",
    "width": 377,
    "height": 515
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#0057b8",
  "property_secondary_color": "#002f6c",
  "property_font_color": null,
  "property_color_4": "#F1BE48",
  "property_color_3": "#69140E",
  "property_color_5": "#a44200",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "657 - 1504",
  "property_sqft_min": "657",
  "property_sqft_max": "1504",
  "property_price_range": "1644 - 9549",
  "property_price_min": "1644",
  "property_price_max": "9549",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/46Penn",
  "property_instagram_url": "https://www.instagram.com/46penn/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJM2ltH8bvwIcRWxmZIcSRkeY",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to 46 Penn Apartment Homes",
  "property_home_romance_title": "Create Lasting Memories in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Resort-inspired amenities, Midtown-Westport energy.</strong> Start the day in the business center, recharge in the fitness center, tanning room, or massage therapy rooms, then unwind by the tiered pool, tanning deck, fire pit lounge, alfresco kitchen, and trellised media area. Everyday convenience comes built in with controlled access, package service, garage parking, EV charging, and on-site maintenance, while select homes add balconies or patios, wine coolers, Plaza views, quartz countertops, stainless steel appliances, and in-home laundry.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find a layout with room for the details.</strong> One- and two-bedroom apartments at 46 Penn pair open living areas with French doors, hardwood-style flooring, quartz countertops, stainless steel appliances, and in-home laundry. Select homes add the extras that make a floor plan stand out: a balcony or patio, built-in desk, kitchen island, wet bar with wine cooler, soaking tub, Plaza views, or a private street-level entrance.</p>",
  "property_home_gallery_blurb": "<p><strong>See 46 Penn in focus.</strong> Preview bright apartment interiors with tall ceilings, French doors, quartz kitchens, pendant lighting, and stainless steel appliances, then look for built-in desks, spacious closets, balconies, patios, and select views. The gallery also captures the tiered pool, tanning deck, fire pit seating, alfresco kitchen, trellised dining, fitness center, lounge, business spaces, and garden moments in Midtown-Westport.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Midtown starts at your door.</strong> From 46 Penn Apartment Homes, stroll toward Plaza storefronts, shaded patios, and fountain-lined streets, or head to Westport for live music, cocktails, and local dining. Mill Creek Park, the Nelson-Atkins Museum of Art, 39th Street, and the Plaza KC Streetcar stop keep more of Kansas City within easy reach. Explore the map, then see how this address connects it all.</p>",
  "property_home_reviews_blurb": "<p><strong>Reviews point to the everyday standouts:</strong> helpful service, prompt maintenance, modern spaces, and clean community areas. Residents also highlight secure garage parking, welcoming events, the pool and gathering spaces, plus easy access to the Plaza. One review says it best: “Everything about this place is first rate!” See more feedback and imagine life at 46 Penn Apartment Homes.</p>",
  "property_neighborhood_blurb": "<p><strong>Step outside and let Midtown set the pace.</strong> From 46 Penn Apartment Homes, your map starts with Plaza storefronts, shaded patios, and fountain-lined streets, then stretches toward Westport’s historic blocks, live music, cocktail lounges, and locally loved restaurants. Spend a slow afternoon near Mill Creek Park or the Nelson-Atkins Museum of Art, meet up along 39th Street for dinner, or use the Plaza KC Streetcar stop to connect north through Midtown, Crossroads, downtown, and the River Market. When you want the energy of the city and an easy return home, this address keeps both close. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood fits around your day.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Designed for easy days and polished nights.</strong> Start with coffee, take a meeting in the business center or conference room, then head to the state-of-the-art fitness center or tanning and massage therapy rooms. When it is time to unwind, the tiered pool with tanning deck, fire pit lounge, alfresco kitchen, BBQ dining space, and trellised media area give 46 Penn Apartment Homes a resort-inspired feel in Midtown-Westport. Practical details are just as considered: concierge-style services, controlled access, package service, private garage parking, EV charging, on-site maintenance, and a guest suite help smooth the day-to-day. Inside, select apartments add French doors to a balcony or patio, built-in desks, wine coolers, kitchen islands, Plaza views, quartz countertops, stainless steel appliances, and in-home laundry. Preview the setting in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_applynow_blurb": "<p><strong>Ready to make 46 Penn home?</strong> Start your application online and move toward polished Plaza-side living with spacious one- and two-bedroom layouts, quartz countertops, stainless steel appliances, in-home laundry, and the everyday ease of a connected Kansas City address.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong><br>Connect with the leasing team at 46 Penn Apartment Homes for help exploring spacious one- and two-bedroom layouts, polished in-home finishes, and a Plaza-side location with easy access to shopping, dining, and KC Streetcar connections.</p>",
  "property_faqs_blurb": "<p><strong>Questions about 46 Penn?</strong> Start here for quick answers on the community, leasing, apartment features, and everyday living in a connected Kansas City location. If you need more detail or want help finding your fit, the leasing team is happy to assist.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the way you want each room to work.</strong> At 46 Penn Apartment Homes, you can compare one-bedroom and two-bedroom floor plans with open living areas, full baths, and select layouts with an added powder room for extra flexibility. French doors invite natural light into the space, while hardwood-style living areas, quartz countertops, stainless steel appliances, and an in-home washer and dryer bring polish to daily routines.</p><p>Choose the details that fit your rhythm: a balcony or patio, a built-in desk, a kitchen island, a wet bar with wine cooler, a soaking tub, Plaza views, or a private street-level entrance in select homes. Explore current availability, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how your next Kansas City apartment could come together.</p>",
  "property_gallery_blurb": "<p><strong>Picture the details before you tour.</strong> In the 46 Penn Apartment Homes photo gallery, you can move from bright living rooms with tall ceilings and French doors to polished kitchens where quartz surfaces, pendant lighting, and stainless steel appliances create a clean, modern backdrop. Look closer for built-in desks, generous closets, balconies, patios, and select views that give each layout its own point of view.</p><p>Then follow the camera outside to the tiered pool and tanning deck, fire pit seating, alfresco kitchen, trellised dining area, fitness center, lounge, business spaces, and quiet garden moments that shape the community experience in Midtown-Westport. Browse the images, compare available <a href=\"/floor-plans\">floor plans</a>, explore the <a href=\"/amenities\">amenities</a>, or see it all in person when you <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore 46 Penn on the map.</strong> See available <a href=\"/floor-plans\">one- and two-bedroom apartments</a> alongside the connected Plaza, Midtown, and Westport surroundings—plus nearby shopping, dining, major area destinations, and KC Streetcar access for easy Kansas City connections.</p>",
  "property_pets_blurb": "<p><strong>A pet-friendly home base in Midtown-Westport.</strong> At 46 Penn Apartment Homes, your cat, dog, or rabbit can settle into a community designed for daily ease—not just a line in the lease. Step out for fresh air in dedicated outdoor pet areas, take a quiet lap through the courtyard, or head back inside to a home with room-friendly touches like hard-surface living areas, patios or balconies in select layouts, and in-home laundry.</p><p>When it is time for a bigger outing, nearby off-leash options like Penn Valley Dog Park keep playtime within easy reach, while controlled access, package service, and on-site maintenance help keep your routine simple. Explore more <a href=\"/amenities\">pet-friendly amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how 46 Penn fits your day-to-day routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share Plaza-side comfort with Midtown momentum.</strong> If you love the polished design, everyday ease, and connected Kansas City location at 46 Penn Apartment Homes, invite a friend to experience it too. Send a referral and help them find their next one- or two-bedroom home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at 46 Penn.</strong><br>Pay rent, submit maintenance requests, and manage your account with everyday ease—right from home. From polished apartment finishes to a connected Plaza-side setting, 46 Penn keeps the essentials simple so resident tasks stay as streamlined as the lifestyle.</p>",
  "property_reviews_blurb": "<p><strong>Resident feedback tells a clear story:</strong> 46 Penn Apartment Homes earns praise for helpful service, modern spaces, and a location residents love. As you browse the reviews, you’ll see frequent mentions of friendly staff, prompt maintenance, clean surroundings, secure garage parking, and community events that make it easy to feel connected.</p><p>Residents also call out the pool area, gathering spaces, and easy access to the Plaza, with one review summing it up simply: “Everything about this place is first rate!” Read what people have shared, then picture your own everyday routine at 46 Penn.</p>",
  "property_created_at": "1785785591510",
  "property_scheduletour_blurb": "<p><strong>See Plaza-side comfort up close.</strong> Tour spacious one- and two-bedroom layouts with quartz countertops, stainless steel appliances, in-home laundry, French doors, and balconies or patios—then explore the polished community spaces that make 46 Penn feel connected, refined, and easy to enjoy. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> The leasing team will be in touch soon to help with your next step. In the meantime, picture polished one- and two-bedroom layouts, refined finishes, and resort-style spaces in a walkable, connected Kansas City location near the Plaza, Midtown, and Westport.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the layout before you visit.</strong> Explore 46 Penn Apartment Homes from wherever you are with immersive apartment tours for the A1, A2, A3, A4, B1, B2, B3, B4, B5, and B6 floor plans. Move through one- and two-bedroom layouts at your own pace, comparing how each entry, kitchen, living area, bedroom, and bath fits the way you use your space.</p><p>As you tour, pay attention to the details that show best in motion: open-concept flow, bright French doors, polished kitchens with quartz-style surfaces and stainless steel appliances, built-in work areas or upgraded entertaining features in select layouts, and balconies, patios, or views where available. When one feels right, compare it on the <a href=\"/floor-plans\">floor plans page</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_copyright": "2026 All Rights Reserved. 46 Penn Apartment Homes",
  "property_seo_title_home": "46 Penn Apartment Homes | Country Club Plaza Apartments",
  "property_seo_description_home": "Discover Country Club Plaza apartments at 46 Penn Apartment Homes. Enjoy 1 & 2 bedroom homes with a saltwater pool, garage parking, and a walkable location.",
  "property_seo_title_floorplans": "Floor Plans | Country Club Plaza Apartments Kansas City",
  "property_seo_description_floorplans": "Compare 1 and 2 bedroom floor plans at 46 Penn, offering a variety of apartments near Country Club Plaza with top amenities.",
  "property_seo_title_amenities": "Amenities | Luxury Apartments on the Plaza, Kansas City",
  "property_seo_description_amenities": "Explore luxury apartments on the Plaza in Kansas City at 46 Penn Apartment Homes, with a saltwater pool, fitness center, EV charging, and pet perks.",
  "property_seo_title_gallery": "Gallery | Apartments Plaza Kansas City, MO",
  "property_seo_description_gallery": "Browse photos of 46 Penn Apartment Homes, offering apartments in Kansas City, MO with quartz kitchens, hardwood floors, a saltwater pool, and more.",
  "property_seo_title_virtualtours": "Virtual Tours | Apartments Plaza, Kansas City, MO",
  "property_seo_description_virtualtours": "Take a virtual tour of 46 Penn Apartment Homes in Kansas City. Watch unit interior videos and explore 1 and 2 bedroom floor plans online anytime.",
  "property_seo_title_interactivemap": "Interactive Map | 46 Penn Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at 46 Penn Apartment Homes in Kansas City. Use our interactive map to explore spacious layouts and premium amenities tailored for you!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments Near UMKC",
  "property_seo_description_neighborhood": "46 Penn Apartment Homes offers apartments near UMKC, one block from the Country Club Plaza and an 8-minute walk to Saint Luke's.",
  "property_seo_title_contact": "Contact Us | UMKC Apartments Near Campus",
  "property_seo_description_contact": "Contact 46 Penn Apartment Homes in Kansas City, MO. Send us a message to ask about availability, tours, and more.",
  "property_seo_title_faqs": "FAQs | Country Club Plaza Apartments",
  "property_seo_description_faqs": "Find answers about leasing, pets, parking, utilities, and renters insurance at 46 Penn Apartment Homes, one block from Country Club Plaza in Kansas City.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kansas City, MO",
  "property_seo_description_reviews": "Discover luxurious living at 46 Penn in Kansas City, MO! See resident reviews and explore our 1 & 2-bedroom homes with excellent amenities.",
  "property_seo_title_applynow": "Apply Now | Apartments in Kansas City, MO",
  "property_seo_description_applynow": "Elevate your lifestyle at 46 Penn Apartment Homes in Kansas City! Modern living awaits with stunning floor plans, top-notch amenities, and a vibrant community.",
  "property_seo_title_residentaccess": "Resident Access | 46 Penn Apartment Homes",
  "property_seo_description_residentaccess": "Unlock convenience at 46 Penn Apartment Homes! Log in to your resident portal for rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | 46 Penn Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to 46 Penn Apartment Homes in Kansas City! Enjoy vibrant living with friendly neighbors. Great friends make the best community—invite them now!",
  "property_seo_title_scheduletour": "Schedule a Tour | Luxury Apartments Plaza Kansas City",
  "property_seo_description_scheduletour": "Tour 46 Penn Apartment Homes, offering apartments near Country Club Plaza in Kansas City. Book a guided in-person tour today.",
  "property_seo_title_privacy": "Privacy Policy | 46 Penn Apartment Homes",
  "property_seo_description_privacy": "At 46 Penn Apartment Homes in Kansas City, MO, your privacy matters. Dive into our policy and see how we protect your personal information.",
  "property_seo_title_accessibility": "Website Accessibility | 46 Penn Apartment Homes",
  "property_seo_description_accessibility": "At 46 Penn Apartment Homes in Kansas City, MO, we prioritize accessibility for all. Join a community where everyone feels welcome and included.",
  "property_seo_title_sitemap": "Sitemap | 46 Penn Apartment Homes",
  "property_seo_description_sitemap": "Navigate your way to convenience at 46 Penn Apartment Homes in Kansas City, MO. Access our sitemap for an effortless journey through your future home!",
  "property_seo_title_thankyou": "Thank You | 46 Penn Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out to 46 Penn Apartment Homes in Kansas City! Our team will connect soon to help you find your perfect urban oasis. Stay tuned!",
  "property_seo_title_pets": "Pet Friendly Apartments in Country Club Plaza, Kansas City",
  "property_seo_description_pets": "Explore pet-friendly apartments at 46 Penn Apartment Homes in Kansas City, with outdoor pet areas and Pet Royalty Club perks. View our full pet policy.",
  "property_updated_at": "1793646111216",
  "amenities": [
    {
      "id": "ec_4c46fdd298c92a0bf8515df6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091563",
      "title": "Private Garage Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81e4abc9d0f6807ee06e502d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091556",
      "title": "Electric Car Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83a225e9fe33be96cb6b2fe4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091567",
      "title": "Tiered Pool with Tanning Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-e183-74c6-b438-54898e43e45c.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with a clear glass wall, surrounded by lounge chairs and apartment buildings.",
        "public_id": "01a01017-e183-74c6-b438-54898e43e45c",
        "storage_key": "property/6767906449167587/01a01017-e183-74c6-b438-54898e43e45c.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Tiered Pool with Tanning Deck at 46 Penn Apartment Homes, MO, 64111,Tiered Pool with Tanning Deck at 46 Penn Apartment Homes, Kansas City, 64111,Tiered Pool with Tanning Deck at 46 Penn Apartment Homes, Kansas City, MO,Tiered Pool with Tanning Deck at 46 Penn Apartment Homes, Kansas City, MO, 64111",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_697f538b4fda4b95cf675db8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091559",
      "title": "Fire Pit with Lounge Seating",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-e16b-71f7-8282-c577e582fb38.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor seating area with fire pit and swimming pool at apartment complex.",
        "public_id": "01a01017-e16b-71f7-8282-c577e582fb38",
        "storage_key": "property/6767906449167587/01a01017-e16b-71f7-8282-c577e582fb38.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Poolside Lounge With Fireplace at 46 Penn Apartment Homes, Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3cfb10bded60afa9c217493",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091552",
      "title": "Alfresco Kitchen w/ Outdoor Dining",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-e15f-703a-a9e2-7470f8df87e8.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs, tables, and string lights.",
        "public_id": "01a01017-e15f-703a-a9e2-7470f8df87e8",
        "storage_key": "property/6767906449167587/01a01017-e15f-703a-a9e2-7470f8df87e8.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Entertainment Lounge With TV at 46 Penn Apartment Homes, Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9509990800ec6848131a7fc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091553",
      "title": "BBQ Grill & Dining Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-e259-749a-be41-41ac45f29718.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool and outdoor lounge area with seating and grilling stations at a modern apartment complex.",
        "public_id": "01a01017-e259-749a-be41-41ac45f29718",
        "storage_key": "property/6767906449167587/01a01017-e259-749a-be41-41ac45f29718.webp",
        "width": 1200,
        "height": 900
      },
      "amenity_image_alt_text": "Tiered Pool with Tanning Deck at 46 Penn Apartment Homes, Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_852a8e85cc738c55bbc58bea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091568",
      "title": "Trellised Dining Area w/ TV & Sound System",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-e0e5-76bb-a3a8-5fd1f43bf2c3.webp",
      "amenity_image_media": {
        "alt_text": "Courtyard with pool and lounge chairs at twilight.",
        "public_id": "01a01017-e0e5-76bb-a3a8-5fd1f43bf2c3",
        "storage_key": "property/6767906449167587/01a01017-e0e5-76bb-a3a8-5fd1f43bf2c3.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A large outdoor pool area at 46 Penn Apartment Homes, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_096767f4c71612f3657ba460",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091565",
      "title": "State-of-the-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-ecc5-71a5-b055-4a7e45fd63c7.webp",
      "amenity_image_media": {
        "alt_text": "Modern fitness center with weight machines, free weights, and TVs.",
        "public_id": "01a01017-ecc5-71a5-b055-4a7e45fd63c7",
        "storage_key": "property/6767906449167587/01a01017-ecc5-71a5-b055-4a7e45fd63c7.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A well-equipped gym with a variety of machines and weights. at 46 Penn Apartment Homes, Kansas City, 64111,Cardio Studio at 46 Penn Apartment Homes, Kansas City, Missouri,A spacious gym with a variety of equipment and a view of a cityscape outside the window. at 46 Penn Apartment Homes, Kansas City, Missouri,A gym with treadmills and exercise equipment. at 46 Penn Apartment Homes, Kansas City, MO, 64111",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d49004a96b0154142885a2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091566",
      "title": "Tanning & Massage Therapy Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-edb6-7039-880a-957f364c85ae.webp",
      "amenity_image_media": {
        "alt_text": "Modern tanning bed and massage chair in a spa room.",
        "public_id": "01a01017-edb6-7039-880a-957f364c85ae",
        "storage_key": "property/6767906449167587/01a01017-edb6-7039-880a-957f364c85ae.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Tanning Machine at 46 Penn Apartment Homes, Kansas City, MO,Spa Room at 46 Penn Apartment Homes, Kansas City, MO,A room with a massage table and a mirror on the wall. at 46 Penn Apartment Homes, Kansas City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f84b0e725c1d15e9d0bc61e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091554",
      "title": "Business Center & Conference Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-ed72-750b-be65-ecee752d2022.webp",
      "amenity_image_media": {
        "alt_text": "Conference room with round table, chairs, and artwork.",
        "public_id": "01a01017-ed72-750b-be65-ecee752d2022",
        "storage_key": "property/6767906449167587/01a01017-ed72-750b-be65-ecee752d2022.webp",
        "width": 1200,
        "height": 799
      },
      "amenity_image_alt_text": "A conference room at 46 Penn Apartment Homes, Kansas City, MO, 64111,Office Setup at 46 Penn Apartment Homes, Kansas City, MO, 64111",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c7a068c7c9d1ad286a932bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091551",
      "title": "24-Hour Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-ee1e-77cc-85b1-d153a76ab1d7.webp",
      "amenity_image_media": {
        "alt_text": "Modern coffee station with a TV screen displaying information and a sleek coffee machine.",
        "public_id": "01a01017-ee1e-77cc-85b1-d153a76ab1d7",
        "storage_key": "property/6767906449167587/01a01017-ee1e-77cc-85b1-d153a76ab1d7.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A modern kitchen with a countertop and a digital display on the wall. at 46 Penn Apartment Homes, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6fe26577a83ee933aece1c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091564",
      "title": "Resident Entertainment Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-ee06-72a9-a039-f3605e39a2eb.webp",
      "amenity_image_media": {
        "alt_text": "Community game room with pool table and view of outdoor pool",
        "public_id": "01a01017-ee06-72a9-a039-f3605e39a2eb",
        "storage_key": "property/6767906449167587/01a01017-ee06-72a9-a039-f3605e39a2eb.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Pool Table In Clubhouse at 46 Penn Apartment Homes, Kansas City, MO, 64111,Community Clubhouse at 46 Penn Apartment Homes, Kansas City, 64111,Clubhouse Billiards Table at 46 Penn Apartment Homes, Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2556ed056d7162c08995b730",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091558",
      "title": "Entertainment-Style Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-f6ea-755f-91d9-aea479d33845.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge with tables, chairs, and a kitchen island.",
        "public_id": "01a01017-f6ea-755f-91d9-aea479d33845",
        "storage_key": "property/6767906449167587/01a01017-f6ea-755f-91d9-aea479d33845.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Coffee Bar Lounge at 46 Penn Apartment Homes, Kansas City, Missouri,A modern kitchen with a dining table and chairs. at 46 Penn Apartment Homes, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01cb0ab44f0fedae6b02bc9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091560",
      "title": "Guest Suite Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-f73a-75f7-938e-69d3b83f85a3.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a king-size bed, a kitchenette, and a dresser with a TV.",
        "public_id": "01a01017-f73a-75f7-938e-69d3b83f85a3",
        "storage_key": "property/6767906449167587/01a01017-f73a-75f7-938e-69d3b83f85a3.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Bedroom With TV at 46 Penn Apartment Homes, Kansas City, MO, 64111,Bedroom Interior at 46 Penn Apartment Homes, Kansas City, MO,a white bathroom with a toilet and a sink at 46 Penn Apartment Homes, Kansas City",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e313c0a844d86db63231bdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091557",
      "title": "Elevator Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_61451f497e247c2cf5bf171d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091550",
      "title": "24-Hour Access Control",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0ed7f03361fd259ab3aa6ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "123148340",
      "title": "Smoke-Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0e8e3aa8626aaf28834fd9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "122755343",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_225a537d94d3a5e2f2f114da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091589",
      "title": "Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bebfa2feeecf93e0f6adddf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091587",
      "title": "Stainless Steel Appliance Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-f6ec-740e-94a2-a6f61be7354a.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island.",
        "public_id": "01a01017-f6ec-740e-94a2-a6f61be7354a",
        "storage_key": "property/6767906449167587/01a01017-f6ec-740e-94a2-a6f61be7354a.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Kitchen Island at 46 Penn Apartment Homes, Kansas City, MO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e432862f457af3e72e4a0fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091585",
      "title": "Side-by-Side Refrigerator with Water & Ice Dispensers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4a34746c0217f8e4fd60a1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091575",
      "title": "Built-In Wine Cooler",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-f80d-7728-b531-1eef5a64d05b.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen and dining area in an apartment with dark wood cabinets, stainless steel appliances, and a dining table.",
        "public_id": "01a01017-f80d-7728-b531-1eef5a64d05b",
        "storage_key": "property/6767906449167587/01a01017-f80d-7728-b531-1eef5a64d05b.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Kitchen And Dining Area at 46 Penn Apartment Homes, Kansas City, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a49a3a813f61aa25cd41c88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091577",
      "title": "Ceran-Top Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_32cb77e651cfa397ed467170",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091580",
      "title": "Kitchen Island*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-fe52-776f-90e0-d9251c410e9e.webp",
      "amenity_image_media": {
        "alt_text": "Modern apartment kitchen with island and dining area.",
        "public_id": "01a01017-fe52-776f-90e0-d9251c410e9e",
        "storage_key": "property/6767906449167587/01a01017-fe52-776f-90e0-d9251c410e9e.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A modern kitchen with a wooden island and a dining table set for two. at 46 Penn Apartment Homes, Kansas City, 64111",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df8e6ab12be3435f7f2bc7f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091590",
      "title": "Wet Bar*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_93efe16dfc6fd9e24b7dd735",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091581",
      "title": "Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ad6a684a3a2575204c56cd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88099372",
      "title": "Plaza Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cf4d8d5f26bcedfbff3ad7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091571",
      "title": "8-Foot French Doors to Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad5423cb48e34d2489e1ed99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091574",
      "title": "Built-In Desk*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f0456a997cb5a5eadc9c083",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091573",
      "title": "11-Foot Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ddb6b12abaf8dbc8ff339277",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091572",
      "title": "9-Foot Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53a491cfb3f70d3e214b0980",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091579",
      "title": "Hardwood Flooring in Living/Dining",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91e-fe71-76df-ab92-3eeae8ee1135.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and island seating.",
        "public_id": "019fc91e-fe71-76df-ab92-3eeae8ee1135",
        "storage_key": "property/6767906449167587/019fc91e-fe71-76df-ab92-3eeae8ee1135.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Stainless Steel Appliances at 46 Penn Apartment Homes, Missouri, 64111",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b079cb7e6737e230f85c988d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091583",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-0331-709e-995c-d411a998af68.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and bathtub with shower.",
        "public_id": "01a01018-0331-709e-995c-d411a998af68",
        "storage_key": "property/6767906449167587/01a01018-0331-709e-995c-d411a998af68.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "White Bathroom at 46 Penn Apartment Homes, Kansas City,A modern kitchen with a white countertop and stainless steel appliances. at 46 Penn Apartment Homes, Missouri, 64111",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac88ca42a511381a4524831f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091584",
      "title": "Recessed and Pendant Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d79158028d2f8d03a2aef9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091576",
      "title": "Ceramic Tile in Bathrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-054f-76fa-8a8c-dcb0bf786021.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom vanity with a walk-in shower and a view into a bedroom.",
        "public_id": "01a01018-054f-76fa-8a8c-dcb0bf786021",
        "storage_key": "property/6767906449167587/01a01018-054f-76fa-8a8c-dcb0bf786021.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A bathroom with a white sink and a mirror above it. at 46 Penn Apartment Homes, Kansas City, 64111",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f271825c5e29d8ceb93d4bf1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091586",
      "title": "Soaking Tub*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-083c-7439-bd18-da82379f1a56.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with vanity, sink, toilet, and bathtub with shower.",
        "public_id": "01a01018-083c-7439-bd18-da82379f1a56",
        "storage_key": "property/6767906449167587/01a01018-083c-7439-bd18-da82379f1a56.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "Modern Bathroom at 46 Penn Apartment Homes, Kansas City, MO, 64111",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c26eaff1014fba2883226cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "external_id": "88091588",
      "title": "Large Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-0d7b-738c-a55a-4a577a8e71f4.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom vanity and walk-in shower with a glimpse of a bedroom.",
        "public_id": "01a01018-0d7b-738c-a55a-4a577a8e71f4",
        "storage_key": "property/6767906449167587/01a01018-0d7b-738c-a55a-4a577a8e71f4.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Bathroom Sink at 46 Penn Apartment Homes, Missouri",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_273fb1b3-6599-49d7-854b-cbd142c74c28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-1eb0-752d-8ad8-5dbc633392e5.webp",
      "image_media": {
        "alt_text": "Modern swimming pool with underwater lighting and glass panel wall.",
        "public_id": "01a01019-1eb0-752d-8ad8-5dbc633392e5",
        "storage_key": "property/6767906449167587/01a01019-1eb0-752d-8ad8-5dbc633392e5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our stunning outdoor pool, featuring unique underwater lighting and a modern glass panel design.",
      "link": "",
      "alt_text": "Modern swimming pool with underwater lighting and glass panel wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7cd9c3d0-57ef-40a3-a59a-af5ae5d44f27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-0deb-7258-a37c-ae5061e6d517.webp",
      "image_media": {
        "alt_text": "Aerial view of an apartment complex courtyard with a pool and lounge chairs.",
        "public_id": "01a01019-0deb-7258-a37c-ae5061e6d517",
        "storage_key": "property/6767906449167587/01a01019-0deb-7258-a37c-ae5061e6d517.webp",
        "width": 1920,
        "height": 1441
      },
      "title": "Community",
      "description": "Experience resort-style living with our stunning outdoor pool and comfortable lounge area, perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Aerial view of an apartment complex courtyard with a pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_946c9bbe-6f7f-4782-9262-6615a53a1ef8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-dbf5-717e-90eb-9b43a8991d86.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area with string lights.",
        "public_id": "01a01018-dbf5-717e-90eb-9b43a8991d86",
        "storage_key": "property/6767906449167587/01a01018-dbf5-717e-90eb-9b43a8991d86.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the refreshing outdoor swimming pool and comfortable lounge area, perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge area with string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57681438-52f9-464c-9bc7-1294d4637498",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-d287-70f9-b5c7-0a59f6be4221.webp",
      "image_media": {
        "alt_text": "Courtyard with pool and lounge chairs at dusk, illuminated by string lights.",
        "public_id": "01a01018-d287-70f9-b5c7-0a59f6be4221",
        "storage_key": "property/6767906449167587/01a01018-d287-70f9-b5c7-0a59f6be4221.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our stunning courtyard featuring a sparkling pool, comfortable lounge chairs, and ambient string lighting, perfect for evening relaxation.",
      "link": "",
      "alt_text": "Courtyard with pool and lounge chairs at dusk, illuminated by string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_19c9e8bf-8b47-49c4-8166-e9e209cfb55f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-b806-756a-a413-cffee2d7c230.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge area with modern seating and string lights.",
        "public_id": "01a01018-b806-756a-a413-cffee2d7c230",
        "storage_key": "property/6767906449167587/01a01018-b806-756a-a413-cffee2d7c230.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling pool or relax in the sun on comfortable lounge chairs. The perfect oasis for unwinding after a long day.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lounge area with modern seating and string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_84ab720f-d959-4efc-85e1-f8b4440343dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-b345-7431-85c8-94194173fc09.webp",
      "image_media": {
        "alt_text": "Modern apartment courtyard with outdoor TV, lounge seating, tables, and a sparkling swimming pool.",
        "public_id": "01a01018-b345-7431-85c8-94194173fc09",
        "storage_key": "property/6767906449167587/01a01018-b345-7431-85c8-94194173fc09.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy resort-style living in our spacious courtyard, featuring an outdoor TV, comfortable lounge areas, and a beautiful swimming pool perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Modern apartment courtyard with outdoor TV, lounge seating, tables, and a sparkling swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_60b1ead1-8ce5-4902-9d0a-82a0182bd586",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-ac15-7179-a956-96b4d6090472.webp",
      "image_media": {
        "alt_text": "Courtyard with a pool, fire pit, and seating areas.",
        "public_id": "01a01018-ac15-7179-a956-96b4d6090472",
        "storage_key": "property/6767906449167587/01a01018-ac15-7179-a956-96b4d6090472.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Enjoy our beautiful courtyard with a sparkling pool, cozy fire pit, and comfortable seating areas.",
      "link": "",
      "alt_text": "Courtyard with a pool, fire pit, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d50b967-8e06-40a9-8e42-4c9b440f9932",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-94fe-747d-93e6-721656e2a5f5.webp",
      "image_media": {
        "alt_text": "Kitchenette area with a coffee maker and sink",
        "public_id": "01a01018-94fe-747d-93e6-721656e2a5f5",
        "storage_key": "property/6767906449167587/01a01018-94fe-747d-93e6-721656e2a5f5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and snacks in our resident lounge kitchenette.",
      "link": "",
      "alt_text": "Kitchenette area with a coffee maker and sink",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e5412399-727e-4f0d-b3b1-41e57073db24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-85d2-754f-a4fa-3da42ae32291.webp",
      "image_media": {
        "alt_text": "Conference room with round table, chairs, and artwork.",
        "public_id": "01a01018-85d2-754f-a4fa-3da42ae32291",
        "storage_key": "property/6767906449167587/01a01018-85d2-754f-a4fa-3da42ae32291.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Host your next meeting in our well-appointed conference room, featuring a round table, comfortable seating, and modern artwork. Perfect for business gatherings.",
      "link": "",
      "alt_text": "Conference room with round table, chairs, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f954b930-f733-426a-9030-047d2d6194a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-7e46-727c-963a-1dedb40b619d.webp",
      "image_media": {
        "alt_text": "Massage room with massage table, a large mirror, and shelves with decor.",
        "public_id": "01a01018-7e46-727c-963a-1dedb40b619d",
        "storage_key": "property/6767906449167587/01a01018-7e46-727c-963a-1dedb40b619d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and rejuvenate in our tranquil massage room, featuring a comfortable massage table, a soothing ambiance, and elegant decor. Your personal sanctuary awaits.",
      "link": "",
      "alt_text": "Massage room with massage table, a large mirror, and shelves with decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80dda726-a125-4910-93d0-3fba95705909",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-7d3f-75c9-931d-19f9f75df2bf.webp",
      "image_media": {
        "alt_text": "Massage chair and tanning bed in a relaxation room.",
        "public_id": "01a01018-7d3f-75c9-931d-19f9f75df2bf",
        "storage_key": "property/6767906449167587/01a01018-7d3f-75c9-931d-19f9f75df2bf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and rejuvenate in our community's wellness room, featuring a massage chair and a tanning bed for your convenience.",
      "link": "",
      "alt_text": "Massage chair and tanning bed in a relaxation room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7be2e609-0a28-40d5-a6fe-09707e40aac8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-7737-70c4-9a8d-6d6a54ed4a32.webp",
      "image_media": {
        "alt_text": "Business center with computers and printer",
        "public_id": "01a01018-7737-70c4-9a8d-6d6a54ed4a32",
        "storage_key": "property/6767906449167587/01a01018-7737-70c4-9a8d-6d6a54ed4a32.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Work or study in our convenient business center, equipped with computers and a printer for resident use.",
      "link": "",
      "alt_text": "Business center with computers and printer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10f74378-0126-4dce-930e-475f4caeb5e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-5e7c-74b3-aa86-fa0d851abd4e.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "01a01018-5e7c-74b3-aa86-fa0d851abd4e",
        "storage_key": "property/6767906449167587/01a01018-5e7c-74b3-aa86-fa0d851abd4e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a wide variety of cardio and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Well-equipped fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7405e890-cf6b-4b8d-979b-a0bd24dd3d68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-5bc8-7376-b1a6-32807fd9f125.webp",
      "image_media": {
        "alt_text": "Treadmills and exercise bikes in a well-lit gym with large windows.",
        "public_id": "01a01018-5bc8-7376-b1a6-32807fd9f125",
        "storage_key": "property/6767906449167587/01a01018-5bc8-7376-b1a6-32807fd9f125.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio equipment and free weights for residents.",
      "link": "",
      "alt_text": "Treadmills and exercise bikes in a well-lit gym with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_92029215-8fc1-477e-8634-5c45ba93fefe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-57ad-753b-9917-a2e8fff242c6.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, dumbbells, and televisions.",
        "public_id": "01a01018-57ad-753b-9917-a2e8fff242c6",
        "storage_key": "property/6767906449167587/01a01018-57ad-753b-9917-a2e8fff242c6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center equipped with a wide array of weight machines, free weights, and cardio equipment for residents to enjoy.",
      "link": "",
      "alt_text": "Fitness center with weight machines, dumbbells, and televisions.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c32385c-0cc5-41ca-9c37-9d51039a9e1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-52c5-7707-8b70-d7a3ccc54fb2.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines including ellipticals and stationary bikes, weights, and yoga balls.",
        "public_id": "01a01018-52c5-7707-8b70-d7a3ccc54fb2",
        "storage_key": "property/6767906449167587/01a01018-52c5-7707-8b70-d7a3ccc54fb2.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, featuring a variety of cardio machines and free weights.",
      "link": "",
      "alt_text": "Fitness center with cardio machines including ellipticals and stationary bikes, weights, and yoga balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ca0fa59b-12ba-4fd2-ae9d-31ad80651b03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-4e18-7388-9651-8b293348ad6c.webp",
      "image_media": {
        "alt_text": "Massage therapy room with massage table, chairs, and spa-like amenities.",
        "public_id": "01a01018-4e18-7388-9651-8b293348ad6c",
        "storage_key": "property/6767906449167587/01a01018-4e18-7388-9651-8b293348ad6c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and rejuvenate in our tranquil massage therapy room, featuring a comfortable massage table, plush seating, and a calming ambiance. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Massage therapy room with massage table, chairs, and spa-like amenities.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_56608524-6634-458b-899d-9cf5b67b5305",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-37db-7273-9f5c-f8ee9b3b77ed.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a sleek kitchen island, bar stools, and a billiards table visible in the background.",
        "public_id": "01a01018-37db-7273-9f5c-f8ee9b3b77ed",
        "storage_key": "property/6767906449167587/01a01018-37db-7273-9f5c-f8ee9b3b77ed.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the upscale amenities in our community lounge, featuring a gourmet kitchen island, comfortable seating, and a billiards table for entertainment.",
      "link": "",
      "alt_text": "Modern community lounge with a sleek kitchen island, bar stools, and a billiards table visible in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_be060e99-c816-4895-b707-83db738dbf8a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, featuring a billiards table and comfortable seating, with a scenic view of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d4e6d49-a31f-46ab-9eed-f024eb84ce64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-2fc0-779d-861d-4cdbab5ddd2b.webp",
      "image_media": {
        "alt_text": "Billiard table in game room with pool and lounge area visible through glass doors",
        "public_id": "01a01018-2fc0-779d-861d-4cdbab5ddd2b",
        "storage_key": "property/6767906449167587/01a01018-2fc0-779d-861d-4cdbab5ddd2b.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community game room, complete with a billiard table and easy access to the sparkling pool and outdoor seating areas.",
      "link": "",
      "alt_text": "Billiard table in game room with pool and lounge area visible through glass doors",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f7971bf-ca72-421d-847e-122d91841ea3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-2f1f-720c-9d40-9bab69a4f60a.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower.",
        "public_id": "01a01018-2f1f-720c-9d40-9bab69a4f60a",
        "storage_key": "property/6767906449167587/01a01018-2f1f-720c-9d40-9bab69a4f60a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience luxury in this modern bathroom, featuring a sleek vanity, a comfortable toilet, and a pristine bathtub with a shower. Your private oasis awaits.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d6f0fc7d-ddaa-4145-9150-0f0ccafba80e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-2e5a-74a9-9179-08f0201b6bf2.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and glass-enclosed shower.",
        "public_id": "01a01018-2e5a-74a9-9179-08f0201b6bf2",
        "storage_key": "property/6767906449167587/01a01018-2e5a-74a9-9179-08f0201b6bf2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish apartment bathroom featuring a spacious vanity with ample counter space, a modern toilet, and a sleek glass-enclosed shower.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and glass-enclosed shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6152efe0-5f0e-4bd9-9eee-aa190d9d50c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-2e39-7729-b875-fcf268cf316f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, sleek cabinetry, and glass-enclosed shower, adjacent to a bedroom.",
        "public_id": "01a01018-2e39-7729-b875-fcf268cf316f",
        "storage_key": "property/6767906449167587/01a01018-2e39-7729-b875-fcf268cf316f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience luxury and comfort in our beautifully appointed bathrooms, featuring spacious vanities and modern walk-in showers, seamlessly flowing into tranquil bedroom spaces.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, sleek cabinetry, and glass-enclosed shower, adjacent to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_565cfb78-b1c7-4220-adab-ff885e0186ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-2e34-76ae-82a0-4dd7530611cf.webp",
      "image_media": {
        "alt_text": "Walk-in closet with clothing and access to a bathroom.",
        "public_id": "01a01018-2e34-76ae-82a0-4dd7530611cf",
        "storage_key": "property/6767906449167587/01a01018-2e34-76ae-82a0-4dd7530611cf.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving and hanging space, featuring a connected bathroom for convenience.",
      "link": "",
      "alt_text": "Walk-in closet with clothing and access to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_169f81fe-33f8-4f6a-bf11-aaa2f89a3945",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-265b-7022-a39f-3abd839d396f.webp",
      "image_media": {
        "alt_text": "Bedroom with TV, ceiling fan, and walk-in closet.",
        "public_id": "01a01018-265b-7022-a39f-3abd839d396f",
        "storage_key": "property/6767906449167587/01a01018-265b-7022-a39f-3abd839d396f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a mounted TV, a ceiling fan, and a convenient walk-in closet with ample storage.",
      "link": "",
      "alt_text": "Bedroom with TV, ceiling fan, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6369a6d-761f-4733-942c-fee07fe0f7bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-2492-738e-b7da-fd357588f744.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, ceiling fan, TV, and window.",
        "public_id": "01a01018-2492-738e-b7da-fd357588f744",
        "storage_key": "property/6767906449167587/01a01018-2492-738e-b7da-fd357588f744.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable bed, a modern ceiling fan, a wall-mounted TV, and large windows with blinds for natural light.",
      "link": "",
      "alt_text": "Bedroom with a bed, ceiling fan, TV, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d06b7bdb-20a9-4862-a3ed-6a76df6016b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-2457-77fb-919e-17c6917ef1a0.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, ceiling fan, and abstract art.",
        "public_id": "01a01018-2457-77fb-919e-17c6917ef1a0",
        "storage_key": "property/6767906449167587/01a01018-2457-77fb-919e-17c6917ef1a0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully appointed bedrooms. Featuring a king-size bed, modern decor, and a ceiling fan for ultimate relaxation.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, ceiling fan, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3010d0a2-fb45-4200-9ecf-c17e9079d40b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-24e6-71e0-963f-f2b90322e618.webp",
      "image_media": {
        "alt_text": "A well-decorated bedroom with a queen-size bed, modern artwork, and a ceiling fan.",
        "public_id": "01a01018-24e6-71e0-963f-f2b90322e618",
        "storage_key": "property/6767906449167587/01a01018-24e6-71e0-963f-f2b90322e618.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, elegant decor, and ample natural light.",
      "link": "",
      "alt_text": "A well-decorated bedroom with a queen-size bed, modern artwork, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eea4ddc2-45f7-4dda-8eca-84915f823177",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-248c-77cf-8509-b3e4ca36352a.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, ceiling fan, and wall-mounted TV.",
        "public_id": "01a01018-248c-77cf-8509-b3e4ca36352a",
        "storage_key": "property/6767906449167587/01a01018-248c-77cf-8509-b3e4ca36352a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom featuring a plush king-size bed, a modern ceiling fan, and a convenient wall-mounted TV for your entertainment.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, ceiling fan, and wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3b3ecdbe-82b8-40f5-b040-6b9fb83e7237",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-1b76-7067-9f49-2c7ccda32267.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building at dusk with a pink and blue sky.",
        "public_id": "01a01018-1b76-7067-9f49-2c7ccda32267",
        "storage_key": "property/6767906449167587/01a01018-1b76-7067-9f49-2c7ccda32267.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Stunning exterior view of this apartment building, showcasing its modern architecture against a beautiful twilight sky. A perfect blend of urban living and comfort.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building at dusk with a pink and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_67ca6c46-c9bb-4401-bd4e-580518f42991",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-1a6d-7297-a7f7-a704075f2116.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island and bar stools.",
        "public_id": "01a01018-1a6d-7297-a7f7-a704075f2116",
        "storage_key": "property/6767906449167587/01a01018-1a6d-7297-a7f7-a704075f2116.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with an island, stainless steel appliances, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen and living area with island and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_656cbcf9-f880-45c1-9d2f-0e2e655e5e21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-1a71-7688-973c-1a45798b0c7e.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and TV, open to a bedroom.",
        "public_id": "01a01018-1a71-7688-973c-1a45798b0c7e",
        "storage_key": "property/6767906449167587/01a01018-1a71-7688-973c-1a45798b0c7e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living area with modern furnishings and a view into the bedroom. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with sectional sofa, coffee table, and TV, open to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b758db65-f8b5-45ec-8013-ab6bd73c7fbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01018-1a47-7049-ab9a-8a86ca7228ce.webp",
      "image_media": {
        "alt_text": "Modern living room with open-concept kitchen and island seating.",
        "public_id": "01a01018-1a47-7049-ab9a-8a86ca7228ce",
        "storage_key": "property/6767906449167587/01a01018-1a47-7049-ab9a-8a86ca7228ce.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern living area featuring an open-concept kitchen with an island, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room with open-concept kitchen and island seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_08e6926e-f665-4504-83fa-c9c6f47630f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-fe52-776f-90e0-d9251c410e9e.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with island and dining area.",
        "public_id": "01a01017-fe52-776f-90e0-d9251c410e9e",
        "storage_key": "property/6767906449167587/01a01017-fe52-776f-90e0-d9251c410e9e.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious apartment kitchen featuring a large island with a sink and wine fridge, sleek cabinetry, and an adjacent dining area perfect for intimate meals.",
      "link": "",
      "alt_text": "Modern apartment kitchen with island and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e031328d-6d91-41b4-af24-af96c20869c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-f73a-75f7-938e-69d3b83f85a3.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, a kitchenette, and a dresser with a TV.",
        "public_id": "01a01017-f73a-75f7-938e-69d3b83f85a3",
        "storage_key": "property/6767906449167587/01a01017-f73a-75f7-938e-69d3b83f85a3.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable king-size bed, a convenient kitchenette with modern appliances, and a dresser topped with a flat-screen TV.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, a kitchenette, and a dresser with a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7038a19b-bc80-448f-b407-deb4d71e73fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-f6ea-755f-91d9-aea479d33845.webp",
      "image_media": {
        "alt_text": "Community lounge with tables, chairs, and a kitchen island.",
        "public_id": "01a01017-f6ea-755f-91d9-aea479d33845",
        "storage_key": "property/6767906449167587/01a01017-f6ea-755f-91d9-aea479d33845.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Gather in our stylish community lounge, featuring comfortable seating, communal tables, and a modern kitchen island, perfect for socializing or working.",
      "link": "",
      "alt_text": "Community lounge with tables, chairs, and a kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7ac933fa-7eea-4271-8fb4-c600dcb0bb0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-f6ec-740e-94a2-a6f61be7354a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island.",
        "public_id": "01a01017-f6ec-740e-94a2-a6f61be7354a",
        "storage_key": "property/6767906449167587/01a01017-f6ec-740e-94a2-a6f61be7354a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, stainless steel appliances, quartz countertops, and a central island, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_30df6437-93bb-4df0-9f9b-2c775e583228",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-e259-749a-be41-41ac45f29718.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and outdoor lounge area with seating and grilling stations at a modern apartment complex.",
        "public_id": "01a01017-e259-749a-be41-41ac45f29718",
        "storage_key": "property/6767906449167587/01a01017-e259-749a-be41-41ac45f29718.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling swimming pool, comfortable lounge seating, and outdoor grilling stations. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Resort-style swimming pool and outdoor lounge area with seating and grilling stations at a modern apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d0042a3b-8e35-4385-822a-a59d227f98c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-e183-74c6-b438-54898e43e45c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with a clear glass wall, surrounded by lounge chairs and apartment buildings.",
        "public_id": "01a01017-e183-74c6-b438-54898e43e45c",
        "storage_key": "property/6767906449167587/01a01017-e183-74c6-b438-54898e43e45c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, featuring a modern glass wall and ample lounge seating for relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with a clear glass wall, surrounded by lounge chairs and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_899d5400-4515-4046-8e34-725934d838bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-e0e5-76bb-a3a8-5fd1f43bf2c3.webp",
      "image_media": {
        "alt_text": "Courtyard with pool and lounge chairs at twilight.",
        "public_id": "01a01017-e0e5-76bb-a3a8-5fd1f43bf2c3",
        "storage_key": "property/6767906449167587/01a01017-e0e5-76bb-a3a8-5fd1f43bf2c3.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the beautiful courtyard at our property, featuring a sparkling pool, comfortable lounge chairs, and ambient string lighting for evening relaxation.",
      "link": "",
      "alt_text": "Courtyard with pool and lounge chairs at twilight.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bcd10457-34e3-4276-86fb-0c571db472a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01017-d29a-70b5-9445-f33f38bb5ec1.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment building exterior with a cityscape in the background at dusk.",
        "public_id": "01a01017-d29a-70b5-9445-f33f38bb5ec1",
        "storage_key": "property/6767906449167587/01a01017-d29a-70b5-9445-f33f38bb5ec1.webp",
        "width": 1200,
        "height": 900
      },
      "title": "Community",
      "description": "Discover luxury living in this stunning apartment community, featuring elegant architecture and a vibrant urban backdrop. Experience the best of city life.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment building exterior with a cityscape in the background at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1a982da0-de30-4c97-9722-16a36cfbbac8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Kura Revolving Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "200 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Creative Japanese restaurant featuring a moving sushi belt and sushi trains, plus a robot server.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-47fc-7159-9a64-fff770e8a7e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-47fc-7159-9a64-fff770e8a7e5",
        "storage_key": "property/6767906449167587/01a0101f-47fc-7159-9a64-fff770e8a7e5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kurasushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14783393984658524480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kura-revolving-sushi-bar",
      "poi_latitude": "39.0424529",
      "poi_longitude": "-94.5894658",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-366-8808",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_twX63vwIcRQMk31oAqKc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_074b6057-a5af-4f41-8f04-1b349997f617",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Jack Stack Barbecue - Plaza",
      "poi_type": "Restaurants",
      "poi_address": "4747 Wyandotte St, Kansas City, MO 64112, USA",
      "poi_short_description": "Bustling local chain known for its vast barbecue menu encompassing steak, seafood, and more.",
      "poi_long_description": "Bustling local chain known for its vast barbecue menu encompassing steak, seafood, and more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-6398-73e2-8b96-7726bec319ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-6398-73e2-8b96-7726bec319ea",
        "storage_key": "property/6767906449167587/019ff6cc-6398-73e2-8b96-7726bec319ea.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.jackstackbbq.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=497015801065317704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-stack-barbecue---plaza",
      "poi_latitude": "39.0412556",
      "poi_longitude": "-94.5886417",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-531-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGYjixLjvwIcRSCVB3jzB5QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_dca15959-5f59-44a2-99ad-543d9d13eb3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "The Capital Grille",
      "poi_type": "Restaurants",
      "poi_address": "4760 Broadway St, Kansas City, MO 64112, USA",
      "poi_short_description": "Outpost of the upscale steakhouse chain offers classic American fare & a clubby, refined setting.",
      "poi_long_description": "Outpost of the upscale steakhouse chain offers classic American fare & a clubby, refined setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-0a52-770a-9024-a248c321c230.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-0a52-770a-9024-a248c321c230",
        "storage_key": "property/6767906449167587/019fc921-0a52-770a-9024-a248c321c230.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.thecapitalgrille.com/locations/mo/kansas-city/kansas-city/8064?cmpid=br:tcg_ag:ie_ch:loc_ca:TCGGMB_sn:gmb_gt:kansas-city-mo-8064_pl:locurl_rd:1057",
      "poi_directions_map_url": "https://maps.google.com/?cid=2807510319733172306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-capital-grille",
      "poi_latitude": "39.0406968",
      "poi_longitude": "-94.5919504",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-531-8345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYcJpLfvwIcRUmjwzsJH9iY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_cf34c237-8c5e-4d69-b112-496db829f06f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Rye Plaza",
      "poi_type": "Restaurants",
      "poi_address": "4646 Mill Creek Pkwy, Kansas City, MO 64112, USA",
      "poi_short_description": "Farm-to-table American fare & rye cocktails served in a stylish, urban-farmhouse setting.",
      "poi_long_description": "Farm-to-table American fare & rye cocktails served in a stylish, urban-farmhouse setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-40b0-72fc-9f15-9de45a287755.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-40b0-72fc-9f15-9de45a287755",
        "storage_key": "property/6767906449167587/01a0101f-40b0-72fc-9f15-9de45a287755.webp",
        "width": 894,
        "height": 1200
      },
      "poi_business_url": "https://www.ryekc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14701347104273267002&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rye-plaza",
      "poi_latitude": "39.0426365",
      "poi_longitude": "-94.5884017",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-541-3382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG2G4s7jvwIcROvns3UytBcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_38a0162e-8015-4ff4-a394-ce9c4edbe7c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Cooper’s Hawk Winery & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4686 Broadway Blvd, Kansas City, MO 64112, USA",
      "poi_short_description": "Upscale chain serving New American fare paired with house-label  wines in a contemporary setting.",
      "poi_long_description": "Upscale chain serving New American fare paired with house-label  wines in a contemporary setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-4044-759d-b65a-1c74233e0ec1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-4044-759d-b65a-1c74233e0ec1",
        "storage_key": "property/6767906449167587/01a0101f-4044-759d-b65a-1c74233e0ec1.webp",
        "width": 1280,
        "height": 965
      },
      "poi_business_url": "https://chwinery.com/locations/missouri/kansas-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=2055704043232815561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coopers-hawk-winery--restaurant",
      "poi_latitude": "39.042566",
      "poi_longitude": "-94.5917549",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-531-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ebQbrjvwIcRyek5jO9Thxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7002f223-def7-44d1-ab78-e7837b7a93d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Fogo de Chão Brazilian Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "222 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_long_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-42fd-7169-ba9a-e87d36e0318a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-42fd-7169-ba9a-e87d36e0318a",
        "storage_key": "property/6767906449167587/01a0101f-42fd-7169-ba9a-e87d36e0318a.webp",
        "width": 1280,
        "height": 779
      },
      "poi_business_url": "https://fogodechao.com/location/kansas-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7229289636537500349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fogo-de-cho-brazilian-steakhouse",
      "poi_latitude": "39.042487",
      "poi_longitude": "-94.5899538",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-931-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNzU0krjvwIcRvQI7PJ-YU2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "custom_c0d5b0af-b287-4f68-af73-b866e3fb3f38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Gram & Dun",
      "poi_type": "Restaurants",
      "poi_address": "600 Ward Pkwy, Kansas City, MO 64112, USA",
      "poi_short_description": "Buzzy venue serving innovative American cuisine in a swanky but warm setting with patio seating.",
      "poi_long_description": "Buzzy venue serving innovative American cuisine in a swanky but warm setting with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-6439-777c-8152-d2d17cc45ce1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-6439-777c-8152-d2d17cc45ce1",
        "storage_key": "property/6767906449167587/019ff6cc-6439-777c-8152-d2d17cc45ce1.webp",
        "width": 1280,
        "height": 917
      },
      "poi_business_url": "http://gramanddun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10690610804177532125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gram--dun",
      "poi_latitude": "39.0403087",
      "poi_longitude": "-94.5940799",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-389-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu3HCerfvwIcR3XT0luKtXJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_802c8b51-bdd0-4b10-866b-5c5d81c105c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Chaz on the Plaza",
      "poi_type": "Restaurants",
      "poi_address": "325 Ward Pkwy, Kansas City, MO 64112, USA",
      "poi_short_description": "Upscale dining on French-influenced American cuisine in a cozy, clubby setting in the Raphael Hotel.",
      "poi_long_description": "Upscale dining on French-influenced American cuisine in a cozy, clubby setting in the Raphael Hotel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-4006-77e8-bcf6-88aaaa10ed67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-4006-77e8-bcf6-88aaaa10ed67",
        "storage_key": "property/6767906449167587/01a0101f-4006-77e8-bcf6-88aaaa10ed67.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.raphaelkc.com/chazontheplaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=975461932068653389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chaz-on-the-plaza",
      "poi_latitude": "39.0395889",
      "poi_longitude": "-94.5913536",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-802-2152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7BtornvwIcRTUnegHWJiQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_57237bd3-cb61-4e13-a555-cf0b9fa73980",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "The Granfalloon Restaurant And Bar",
      "poi_type": "Restaurants",
      "poi_address": "608 Ward Pkwy, Kansas City, MO 64112, USA",
      "poi_short_description": "This bi-level bar & eatery boasts sports-tuned TVs, upscale pub fare & an open, casual dining room.",
      "poi_long_description": "This bi-level bar & eatery boasts sports-tuned TVs, upscale pub fare & an open, casual dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-4006-77e8-bcf6-853d5391ba4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-4006-77e8-bcf6-853d5391ba4a",
        "storage_key": "property/6767906449167587/01a0101f-4006-77e8-bcf6-853d5391ba4a.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.thegranfalloon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13162227725759642147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-granfalloon-restaurant-and-bar",
      "poi_latitude": "39.040159",
      "poi_longitude": "-94.594674",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-753-7850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnekLcLfvwIcRI3qzTmGgqbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e9b859f2-e4b3-4c07-bd55-a37543dba4c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Ragazza Food & Wine",
      "poi_type": "Restaurants",
      "poi_address": "4301 Main St, Kansas City, MO 64111, USA",
      "poi_short_description": "Classic Italian eats & an extensive wine list offered in an intimate setting with a bar & fireplace.",
      "poi_long_description": "Classic Italian eats & an extensive wine list offered in an intimate setting with a bar & fireplace.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc920-fd0f-714d-b86a-1700db7b2cf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-fd0f-714d-b86a-1700db7b2cf1",
        "storage_key": "property/6767906449167587/019fc920-fd0f-714d-b86a-1700db7b2cf1.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "http://www.ragazzakc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4468954534655945133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ragazza-food--wine",
      "poi_latitude": "39.0492274",
      "poi_longitude": "-94.5863455",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-960-4744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJeRpVscTvwIcRremJw3jqBD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_a28c8c5e-f08f-4f80-b665-9c73f918e941",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Café Sebastienne",
      "poi_type": "Restaurants",
      "poi_address": "4420 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Stylish New American cafe in the Kemper Museum with an art-lined dining room & courtyard atrium.",
      "poi_long_description": "Stylish New American cafe in the Kemper Museum with an art-lined dining room & courtyard atrium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-42fd-7169-ba9a-edf669900689.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-42fd-7169-ba9a-edf669900689",
        "storage_key": "property/6767906449167587/01a0101f-42fd-7169-ba9a-edf669900689.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.oil-on-linen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14503020364162386550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-sebastienne",
      "poi_latitude": "39.0464663",
      "poi_longitude": "-94.5848299",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-457-6172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjz4brcHvwIcRdsonUC4URck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_92dff4e0-3328-443b-b050-41e059c1ecdf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "The Classic Cup Cafe",
      "poi_type": "Restaurants",
      "poi_address": "301 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Casual staple providing an extensive menu of American cooking, plus outdoor seating.",
      "poi_long_description": "Casual staple providing an extensive menu of American cooking, plus outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-695d-7535-8219-4a707d3755ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-695d-7535-8219-4a707d3755ac",
        "storage_key": "property/6767906449167587/019ff6cc-695d-7535-8219-4a707d3755ac.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://theclassiccupcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15530999025163790290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-classic-cup-cafe",
      "poi_latitude": "39.0421573",
      "poi_longitude": "-94.5908287",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-753-1840",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-9aef-723d-a4aa-e5628b7f6dab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6cc-9aef-723d-a4aa-e5628b7f6dab",
        "storage_key": "property/6767906449167587/019ff6cc-9aef-723d-a4aa-e5628b7f6dab.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJD7E2WbjvwIcR0mfTnVMxidc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_c495c675-8ae5-4763-ae3d-58cb12d3330a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "The Roasterie Factory Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1204 W 27th St, Kansas City, MO 64108, USA",
      "poi_short_description": "Cafe dealing in coffeehouse beverages & baked goods in a relaxed space with hangout potential.",
      "poi_long_description": "Cafe dealing in coffeehouse beverages & baked goods in a relaxed space with hangout potential.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-43eb-757c-870a-358cfabf4fcf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-43eb-757c-870a-358cfabf4fcf",
        "storage_key": "property/6767906449167587/01a0101f-43eb-757c-870a-358cfabf4fcf.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://theroasterie.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5750088935067557655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-roasterie-factory-cafe",
      "poi_latitude": "39.0788572",
      "poi_longitude": "-94.5986035",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-931-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-9aef-723d-a4aa-e5628b7f6dab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6cc-9aef-723d-a4aa-e5628b7f6dab",
        "storage_key": "property/6767906449167587/019ff6cc-9aef-723d-a4aa-e5628b7f6dab.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ7ZAS4zPwwIcRFx-b0WtrzE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_ced31e87-721a-4673-bef7-f1660f35a321",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Levee Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "16 W 43rd St, Kansas City, MO 64111, USA",
      "poi_short_description": "Veteran venue in a historic neighborhood with live music on the main floor & a sports bar upstairs.",
      "poi_long_description": "Veteran venue in a historic neighborhood with live music on the main floor & a sports bar upstairs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-437d-7415-bdf6-cd70bdde9a7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-437d-7415-bdf6-cd70bdde9a7e",
        "storage_key": "property/6767906449167587/01a0101f-437d-7415-bdf6-cd70bdde9a7e.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://orderonlinemenu.com/LeveeBarGrill",
      "poi_directions_map_url": "https://maps.google.com/?cid=14075133920971543659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "levee-bar--grill",
      "poi_latitude": "39.0495121",
      "poi_longitude": "-94.5871906",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-301-4619",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-714f-7708-ac60-ef4e8b9c96ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-714f-7708-ac60-ef4e8b9c96ef",
        "storage_key": "property/6767906449167587/019fc921-714f-7708-ac60-ef4e8b9c96ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHW7t7sPvwIcRa1SPVbrrVMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_9db2cd36-b917-40a7-9163-1f5ddfa2e3c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "McCormick & Schmick's Seafood & Steaks",
      "poi_type": "Restaurants",
      "poi_address": "448 W 47th St, Kansas City, MO 64112, USA",
      "poi_short_description": "Upscale steak & seafood chain known for its clubby environs & happy hour.",
      "poi_long_description": "Upscale steak & seafood chain known for its clubby environs & happy hour.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc920-fcde-760c-8d01-4b86f3015f9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-fcde-760c-8d01-4b86f3015f9a",
        "storage_key": "property/6767906449167587/019fc920-fcde-760c-8d01-4b86f3015f9a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mccormickandschmicks.com/location/mccormick-schmicks-kansas-city-mo/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17792790613339746772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mccormick--schmicks-seafood--steaks",
      "poi_latitude": "39.0426046",
      "poi_longitude": "-94.5932546",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-531-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-ae09d30fecce",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-ae09d30fecce.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxfqiCbjvwIcR1DEF58qw7PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a5790aac-93c5-425a-8660-b413b57802ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "5011 Main St, Kansas City, MO 64112, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-71a6-768e-8f1d-db6e8074c2a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-71a6-768e-8f1d-db6e8074c2a6",
        "storage_key": "property/6767906449167587/019ff6cc-71a6-768e-8f1d-db6e8074c2a6.webp",
        "width": 1280,
        "height": 629
      },
      "poi_business_url": "https://www.cvs.com/store-locator/kansas-city-mo-pharmacies/5011-main-st-kansas-city-mo-64112/storeid=8567?WT.mc_id=LS_GOOGLE_FS_8567",
      "poi_directions_map_url": "https://maps.google.com/?cid=8406075267570829173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "39.0360471",
      "poi_longitude": "-94.5868685",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-531-4699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEfH_ZrzvwIcRdYfBJutgqHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_61bd4500-7a03-4459-bc53-8a751039625b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "3845 Broadway Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-4890-70a7-956c-8d1c58fbc63e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-4890-70a7-956c-8d1c58fbc63e",
        "storage_key": "property/6767906449167587/01a0101f-4890-70a7-956c-8d1c58fbc63e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3845+broadway+blvd-kansas+city-mo-64111/id=5278",
      "poi_directions_map_url": "https://maps.google.com/?cid=15848482437788268161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.05738789999999",
      "poi_longitude": "-94.5901947",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-561-7620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTrIudvvwIcRgfZi7c4e8ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_ae7e765a-0c80-4205-979f-3c37b300a8cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Cosentino's Price Chopper",
      "poi_type": "Shopping & Retail",
      "poi_address": "6327 Brookside Plaza, Kansas City, MO 64113, USA",
      "poi_short_description": "Urban grocery store offering produce, meats and baked goods along with beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-49bc-756e-9184-1c57ae662d25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-49bc-756e-9184-1c57ae662d25",
        "storage_key": "property/6767906449167587/01a0101f-49bc-756e-9184-1c57ae662d25.webp",
        "width": 1280,
        "height": 824
      },
      "poi_business_url": "https://www.mypricechopper.com/store-details?storeId=82",
      "poi_directions_map_url": "https://maps.google.com/?cid=5601713248782007001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-price-chopper",
      "poi_latitude": "39.01302250000001",
      "poi_longitude": "-94.5903738",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-523-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7157-7570-9f6b-13b0994cd8c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7157-7570-9f6b-13b0994cd8c2",
        "storage_key": "property/6767906449167587/019fc921-7157-7570-9f6b-13b0994cd8c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbd8NA7vwIcR2TpAR4VIvU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_205ae09d-7ee2-4955-8839-702685db8cf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Cosentino's Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "14 W 62 Terrace, Kansas City, MO 64113, USA",
      "poi_short_description": "Relaxed supermarket selling organic eats, baked goods, wine and prepared dishes, with a salad bar, plus helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-4ad7-74ff-a4ed-2769c740bd9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-4ad7-74ff-a4ed-2769c740bd9d",
        "storage_key": "property/6767906449167587/01a0101f-4ad7-74ff-a4ed-2769c740bd9d.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "http://cosentinos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13117215859270891575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cosentinos-market",
      "poi_latitude": "39.0150001",
      "poi_longitude": "-94.5888037",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 816-523-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7157-7570-9f6b-13b0994cd8c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7157-7570-9f6b-13b0994cd8c2",
        "storage_key": "property/6767906449167587/019fc921-7157-7570-9f6b-13b0994cd8c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYPViQ7vwIcRNzj2dVO2CbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_1d2ab263-b521-4157-b83f-22a503313337",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "8600 Ward Pkwy, Kansas City, MO 64114, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91e-228e-76d8-a11e-c66d75fe574a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91e-228e-76d8-a11e-c66d75fe574a",
        "storage_key": "property/6767906449167587/019fc91e-228e-76d8-a11e-c66d75fe574a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/mo/kansas-city/720/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13718771023150469206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.9713402",
      "poi_longitude": "-94.6064342",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-333-5322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7157-7570-9f6b-13b0994cd8c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7157-7570-9f6b-13b0994cd8c2",
        "storage_key": "property/6767906449167587/019fc921-7157-7570-9f6b-13b0994cd8c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJda3_VSbpwIcRVlDOdY_dYr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4af93fad-7c99-4e3b-86eb-c8765bb41f65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "7511 Wornall Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-49c9-7647-a2b1-b179be1b8fbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-49c9-7647-a2b1-b179be1b8fbd",
        "storage_key": "property/6767906449167587/01a0101f-49c9-7647-a2b1-b179be1b8fbd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/mo/kansas-city/7511-wornall-road/f300",
      "poi_directions_map_url": "https://maps.google.com/?cid=894879846790879640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "38.991599",
      "poi_longitude": "-94.592771",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7157-7570-9f6b-13b0994cd8c2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7157-7570-9f6b-13b0994cd8c2",
        "storage_key": "property/6767906449167587/019fc921-7157-7570-9f6b-13b0994cd8c2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZfjWCXvwIcRmFmguHpAaww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_2f40de99-7c7b-4f7f-a78f-39b7ec859e38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "8509 State Line Rd, Kansas City, MO 64114, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-4c0e-708c-bb1c-91f248a4bd42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-4c0e-708c-bb1c-91f248a4bd42",
        "storage_key": "property/6767906449167587/01a0101f-4c0e-708c-bb1c-91f248a4bd42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/ward-parkway/1436",
      "poi_directions_map_url": "https://maps.google.com/?cid=10429168010455215149&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.9717354",
      "poi_longitude": "-94.6074334",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 816-444-6012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7155-765a-9f87-197ccc69a90c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7155-765a-9f87-197ccc69a90c",
        "storage_key": "property/6767906449167587/019fc921-7155-765a-9f87-197ccc69a90c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh4wORSnpwIcRLewMpgzZu5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_5124b929-9593-455e-a97c-1084192a76f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "1014 Westport Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-4c83-769f-bd7d-641a91d0abbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-4c83-769f-bd7d-641a91d0abbf",
        "storage_key": "property/6767906449167587/01a0101f-4c83-769f-bd7d-641a91d0abbf.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/mo/kansas-city/1014-westport-rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7502023764040119964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "39.0506245",
      "poi_longitude": "-94.5993629",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-601-2660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7155-765a-9f87-197ccc69a90c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7155-765a-9f87-197ccc69a90c",
        "storage_key": "property/6767906449167587/019fc921-7155-765a-9f87-197ccc69a90c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ03Zxns7vwIcRnHYmsN2KHGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_fa23facc-ed01-4bb5-af3e-3cc844ebcb50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "World Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "535 Westport Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "Retail chain featuring an eclectic array of imported housewares, furniture, decor & specialty foods.",
      "poi_long_description": "Retail chain featuring an eclectic array of imported housewares, furniture, decor & specialty foods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-4d31-7499-b2f1-b121dcef590c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-4d31-7499-b2f1-b121dcef590c",
        "storage_key": "property/6767906449167587/01a0101f-4d31-7499-b2f1-b121dcef590c.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.worldmarket.com/stores/store?id=CP195",
      "poi_directions_map_url": "https://maps.google.com/?cid=4372832946125895678&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "world-market",
      "poi_latitude": "39.0517181",
      "poi_longitude": "-94.5930693",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-931-3590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7155-765a-9f87-197ccc69a90c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7155-765a-9f87-197ccc69a90c",
        "storage_key": "property/6767906449167587/019fc921-7155-765a-9f87-197ccc69a90c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgeDsaMXvwIcR_nf1b2Vsrzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_09c2a69f-8d46-4a47-9e95-d805f222d50c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Country Club Plaza",
      "poi_type": "Shopping & Retail",
      "poi_address": "4706 Broadway Blvd, Kansas City, MO 64112, USA",
      "poi_short_description": "Sprawling shopping area made up of Moorish-themed buildings housing stores & restaurants.",
      "poi_long_description": "Sprawling shopping area made up of Moorish-themed buildings housing stores & restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6c8-67ae-7112-bef1-324b98cd41fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6c8-67ae-7112-bef1-324b98cd41fa",
        "storage_key": "property/6767906449167587/019ff6c8-67ae-7112-bef1-324b98cd41fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://countryclubplaza.com/?utm_source=GoogleMyBusiness&utm_medium=Organic&utm_campaign=GMB",
      "poi_directions_map_url": "https://maps.google.com/?cid=12339093817016807577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "country-club-plaza",
      "poi_latitude": "39.0419692",
      "poi_longitude": "-94.5926089",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-753-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7155-765a-9f87-197ccc69a90c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7155-765a-9f87-197ccc69a90c",
        "storage_key": "property/6767906449167587/019fc921-7155-765a-9f87-197ccc69a90c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr4r_377vwIcRmXCBhXNEPas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_882f27a4-bc3e-4703-b469-6d640cf95f6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "University of Missouri-Kansas City",
      "poi_type": "Education",
      "poi_address": "5000 Holmes St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91e-27a3-716a-94bd-e61caf5c3afd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91e-27a3-716a-94bd-e61caf5c3afd",
        "storage_key": "property/6767906449167587/019fc91e-27a3-716a-94bd-e61caf5c3afd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.umkc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660093312754521544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-missouri-kansas-city",
      "poi_latitude": "39.0333035",
      "poi_longitude": "-94.577545",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-235-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-716f-77bd-a20c-2d7e6781705c",
        "storage_key": "property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ856Hn5DvwIcRyBVAa2NC8JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c5a8506d-7a0d-434c-9000-fac566ad95e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Rockhurst University",
      "poi_type": "Education",
      "poi_address": "1100 Rockhurst Rd, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91e-240c-71ab-a265-e6ccc88937e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91e-240c-71ab-a265-e6ccc88937e2",
        "storage_key": "property/6767906449167587/019fc91e-240c-71ab-a265-e6ccc88937e2.webp",
        "width": 960,
        "height": 320
      },
      "poi_business_url": "https://www.rockhurst.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16644960823377639958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockhurst-university",
      "poi_latitude": "39.0303478",
      "poi_longitude": "-94.5710674",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-501-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-716f-77bd-a20c-2d7e6781705c",
        "storage_key": "property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU6rD5oTvwIcRFrq3Ga7H_uY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ae1ab330-ff8c-4a76-a307-b080bd14c0a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Kansas City Art Institute",
      "poi_type": "Education",
      "poi_address": "4415 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-7949-738c-b3e9-e1fe5f2643ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-7949-738c-b3e9-e1fe5f2643ea",
        "storage_key": "property/6767906449167587/019ff6cc-7949-738c-b3e9-e1fe5f2643ea.webp",
        "width": 705,
        "height": 670
      },
      "poi_business_url": "http://www.kcai.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3056374416396262313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-art-institute",
      "poi_latitude": "39.0466734",
      "poi_longitude": "-94.5834059",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-472-4852",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-716f-77bd-a20c-2d7e6781705c",
        "storage_key": "property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJffVj1cHvwIcRqRvknVZsaio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1f6b9d78-2307-4c28-b5bd-f9bca11796fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "The Linda Hall: Science Library and Arboretum",
      "poi_type": "Education",
      "poi_address": "5109 Cherry St, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-4ed8-749b-978d-2c00f4ac6383.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-4ed8-749b-978d-2c00f4ac6383",
        "storage_key": "property/6767906449167587/01a0101f-4ed8-749b-978d-2c00f4ac6383.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.lindahall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2244179871647189902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-linda-hall-science-library-and-arboretum",
      "poi_latitude": "39.033339",
      "poi_longitude": "-94.579467",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-363-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6c8-9b57-7677-a836-e15768a13308.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6c8-9b57-7677-a836-e15768a13308",
        "storage_key": "property/6767906449167587/019ff6c8-9b57-7677-a836-e15768a13308.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJR1iM5pnvwIcRjsuc_bPtJB8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_aadc35a8-f729-422b-992c-cd198f16146e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Paseo Academy of Fine and Performing Arts",
      "poi_type": "Education",
      "poi_address": "4747 Flora Ave, Kansas City, MO 64110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-4126-74a9-953b-4cb52e0a66b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-4126-74a9-953b-4cb52e0a66b5",
        "storage_key": "property/6767906449167587/019fc921-4126-74a9-953b-4cb52e0a66b5.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://paseo.kcpublicschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2671712777832996564&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paseo-academy-of-fine-and-performing-arts",
      "poi_latitude": "39.0391547",
      "poi_longitude": "-94.5656629",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-418-2275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-716f-77bd-a20c-2d7e6781705c",
        "storage_key": "property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUwEDfYnvwIcR1J6buJ3UEyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_6117628e-7c60-457a-8992-eb35e956a1a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Gordon Parks Elementary School",
      "poi_type": "Education",
      "poi_address": "3715 Wyoming St, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-4ed8-749b-978d-33dd5453cdde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-4ed8-749b-978d-33dd5453cdde",
        "storage_key": "property/6767906449167587/01a0101f-4ed8-749b-978d-33dd5453cdde.webp",
        "width": 1201,
        "height": 463
      },
      "poi_business_url": "http://www.gordonparks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8700588777770038279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gordon-parks-elementary-school",
      "poi_latitude": "39.0602375",
      "poi_longitude": "-94.6029569",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-753-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-716f-77bd-a20c-2d7e6781705c",
        "storage_key": "property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv1Tmw9TvwIcRB7S7S2Wzvng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_03beffa0-13aa-4841-b718-6565f8df4969",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Hale Cook Elementary School",
      "poi_type": "Education",
      "poi_address": "7302 Pennsylvania Ave, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kcpublicschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8446085057482167704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hale-cook-elementary-school",
      "poi_latitude": "38.9953897",
      "poi_longitude": "-94.5969492",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-418-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-716f-77bd-a20c-2d7e6781705c",
        "storage_key": "property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlRqPaSTvwIcRmJX1SZyFNnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_55ae7567-9d6b-4252-adcb-261b36f34d86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Central High School",
      "poi_type": "Education",
      "poi_address": "3221 Indiana Ave, Kansas City, MO 64128, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-7833-7178-8aba-bafcd3c95c27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-7833-7178-8aba-bafcd3c95c27",
        "storage_key": "property/6767906449167587/019ff6cc-7833-7178-8aba-bafcd3c95c27.webp",
        "width": 1280,
        "height": 977
      },
      "poi_business_url": "https://www.kcpublicschools.org/central",
      "poi_directions_map_url": "https://maps.google.com/?cid=7694742480629455486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-high-school",
      "poi_latitude": "39.06676300000001",
      "poi_longitude": "-94.541744",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 816-418-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-716f-77bd-a20c-2d7e6781705c",
        "storage_key": "property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5RUJH5TlwIcRftoGhIQ3yWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_220ee42c-b4b1-4906-9ad9-613f8e38870e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Tierra Encantada - Brookside",
      "poi_type": "Education",
      "poi_address": "114 W Gregory Blvd, Kansas City, MO 64114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-50ba-72ef-8df4-5e13225ddee1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-50ba-72ef-8df4-5e13225ddee1",
        "storage_key": "property/6767906449167587/01a0101f-50ba-72ef-8df4-5e13225ddee1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.tierraencantada.com/locations/brookside/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8815400436702725932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tierra-encantada---brookside",
      "poi_latitude": "38.9996766",
      "poi_longitude": "-94.5912607",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-451-7442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-716f-77bd-a20c-2d7e6781705c",
        "storage_key": "property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ536WRqLvwIcRLEd9vv2XVno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_372467bd-33bd-4581-b605-f42c18b705e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Resurrection Brookside",
      "poi_type": "Education",
      "poi_address": "5144 Oak St, Kansas City, MO 64112, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-5013-746f-be8a-49520b90a22b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-5013-746f-be8a-49520b90a22b",
        "storage_key": "property/6767906449167587/01a0101f-5013-746f-be8a-49520b90a22b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://resurrection.church/brookside/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11347028930218772795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "resurrection-brookside",
      "poi_latitude": "39.0328651",
      "poi_longitude": "-94.5835193",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-753-1844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-6aa8-75d7-864d-05625218885d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0101f-6aa8-75d7-864d-05625218885d",
        "storage_key": "property/6767906449167587/01a0101f-6aa8-75d7-864d-05625218885d.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJyy6rrqLvwIcRO0nFYbG-eJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_9b141102-b780-4be8-a4a0-d343cd14a728",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "The Nelson-Atkins Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "4525 Oak St, Kansas City, MO 64111, USA",
      "poi_short_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_long_description": "Art collection spanning 5,000 years in neoclassical & modern galleries, plus a sculpture garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91e-3b77-706a-b139-05c6fb87a28e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91e-3b77-706a-b139-05c6fb87a28e",
        "storage_key": "property/6767906449167587/019fc91e-3b77-706a-b139-05c6fb87a28e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nelson-atkins.org/?utm_source=gmb&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3122843275976164549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-nelson-atkins-museum-of-art",
      "poi_latitude": "39.0449506",
      "poi_longitude": "-94.5809284",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-751-1278",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-717c-7528-95c8-dfe665912dba",
        "storage_key": "property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRSCf3ervwIcRxcTG-WmRVis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_2741340a-1bd4-4346-bb96-ee0a0e0cc189",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Kemper Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "4420 Warwick Blvd, Kansas City, MO 64111, USA",
      "poi_short_description": "Modest museum housing a permanent collection & special exhibitions of challenging contemporary art.",
      "poi_long_description": "Modest museum housing a permanent collection & special exhibitions of challenging contemporary art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-4b11-71ac-8bb2-5356f8ae83f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-4b11-71ac-8bb2-5356f8ae83f9",
        "storage_key": "property/6767906449167587/019fc921-4b11-71ac-8bb2-5356f8ae83f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kemperart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4417124555838519064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kemper-museum-of-contemporary-art",
      "poi_latitude": "39.04643",
      "poi_longitude": "-94.5851292",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-753-5784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-717c-7528-95c8-dfe665912dba",
        "storage_key": "property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjz4brcHvwIcRGPdob2HHTD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_31211453-f645-4153-92af-bcd2fd7f9e6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "The National Museum of Toys and Miniatures",
      "poi_type": "Entertainment",
      "poi_address": "5235 Oak St, Kansas City, MO 64112, USA",
      "poi_short_description": "Eclectic array of collectible toys, antique marbles & miniature reproductions of fine furnishings.",
      "poi_long_description": "Eclectic array of collectible toys, antique marbles & miniature reproductions of fine furnishings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-5141-757b-a647-9001629a5617.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-5141-757b-a647-9001629a5617",
        "storage_key": "property/6767906449167587/01a0101f-5141-757b-a647-9001629a5617.webp",
        "width": 1280,
        "height": 1014
      },
      "poi_business_url": "http://www.toyandminiaturemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3778476980352128529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-national-museum-of-toys-and-miniatures",
      "poi_latitude": "39.0307741",
      "poi_longitude": "-94.5820813",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-235-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-717c-7528-95c8-dfe665912dba",
        "storage_key": "property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLdcuZ5jvwIcRERbhXcvYbzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_9c3c8e33-8045-4d5c-838d-7b173d2daccd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Kauffman Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "1601 Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_long_description": "2 performance halls joined together under a glass dome, hosting music, opera, theater & dance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-585f-755e-b13a-f34886677068.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-585f-755e-b13a-f34886677068",
        "storage_key": "property/6767906449167587/019fc921-585f-755e-b13a-f34886677068.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kauffmancenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6371724031435486048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kauffman-center-for-the-performing-arts",
      "poi_latitude": "39.0941068",
      "poi_longitude": "-94.5876247",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-994-7222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99d4bkPwwIcRYDOIbD_pbFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_93284578-9445-4f02-99d0-b8be5d2aff93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "National WWI Museum and Memorial",
      "poi_type": "Entertainment",
      "poi_address": "2 Memorial Dr, Kansas City, MO 64108, USA",
      "poi_short_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_long_description": "The nation's only public museum dedicated to WWI, with a large collection of photos, weapons & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-7ce7-748e-849a-eaab93776c07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-7ce7-748e-849a-eaab93776c07",
        "storage_key": "property/6767906449167587/019ff6cc-7ce7-748e-849a-eaab93776c07.webp",
        "width": 1280,
        "height": 1071
      },
      "poi_business_url": "https://www.theworldwar.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10469991631701161311&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "national-wwi-museum-and-memorial",
      "poi_latitude": "39.080663",
      "poi_longitude": "-94.5860835",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-888-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-717c-7528-95c8-dfe665912dba",
        "storage_key": "property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJpzAyJjzwwIcRXzXcqOrhTJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d384b90d-3a9f-445d-a14b-6d306ec33f47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Negro Leagues Baseball Museum",
      "poi_type": "Entertainment",
      "poi_address": "1616 E 18th St, Kansas City, MO 64108, USA",
      "poi_short_description": "Exhibits on segregated league's 1920 founding to Jackie Robinson's 1947 Brooklyn Dodgers debut.",
      "poi_long_description": "Exhibits on segregated league's 1920 founding to Jackie Robinson's 1947 Brooklyn Dodgers debut.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-55aa-76fd-b1cb-f577a5637165.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-55aa-76fd-b1cb-f577a5637165",
        "storage_key": "property/6767906449167587/019fc921-55aa-76fd-b1cb-f577a5637165.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nlbm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11911160217324044073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "negro-leagues-baseball-museum",
      "poi_latitude": "39.0913923",
      "poi_longitude": "-94.5626542",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-221-1920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-717c-7528-95c8-dfe665912dba",
        "storage_key": "property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YLPAHbwwIcRKT9dEBzxTKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8cad235a-a8a7-4c2c-905b-1efaf915052b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Science City at Union Station",
      "poi_type": "Entertainment",
      "poi_address": "30 W Pershing Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "Family-friendly museum with interactive science displays, including a test kitchen & planetarium.",
      "poi_long_description": "Family-friendly museum with interactive science displays, including a test kitchen & planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-5264-71af-8271-93fd94fb9173.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-5264-71af-8271-93fd94fb9173",
        "storage_key": "property/6767906449167587/01a0101f-5264-71af-8271-93fd94fb9173.webp",
        "width": 720,
        "height": 541
      },
      "poi_business_url": "http://www.unionstation.org/sciencecity",
      "poi_directions_map_url": "https://maps.google.com/?cid=12787524424421866697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "science-city-at-union-station",
      "poi_latitude": "39.085408",
      "poi_longitude": "-94.5861467",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-460-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-717c-7528-95c8-dfe665912dba",
        "storage_key": "property/6767906449167587/019fc921-717c-7528-95c8-dfe665912dba.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_t4g0DwwIcRyfxLerZpdrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a75c111b-2ffe-4c7e-8dc5-9ffa502a802e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "B&B Theatres KC Extreme Screen Union Station",
      "poi_type": "Entertainment",
      "poi_address": "30 W Pershing Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "Family-run movie theater in a train station, known for its 80-by-53-foot screen with 3D capability.",
      "poi_long_description": "Family-run movie theater in a train station, known for its 80-by-53-foot screen with 3D capability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-538c-7427-a057-f6902b23f830.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-538c-7427-a057-f6902b23f830",
        "storage_key": "property/6767906449167587/01a0101f-538c-7427-a057-f6902b23f830.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://extremescreen.unionstation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16333279347611528106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-kc-extreme-screen-union-station",
      "poi_latitude": "39.0848525",
      "poi_longitude": "-94.5860392",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 816-460-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-6ad5-717d-9440-1ac929628de0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0101f-6ad5-717d-9440-1ac929628de0",
        "storage_key": "property/6767906449167587/01a0101f-6ad5-717d-9440-1ac929628de0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJp391fz_wwIcRquubewd3q-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a5395aa3-aa7f-43d3-9ef7-4dfb8ecacdaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "LEGOLAND Discovery Center Kansas City",
      "poi_type": "Entertainment",
      "poi_address": "2475 Grand Blvd East Retail Suite 200; Crown Center Shops, Kansas City, MO 64108, USA",
      "poi_short_description": "Family entertainment center featuring Lego toy displays, rides & a 4-D theater, plus a gift shop.",
      "poi_long_description": "Family entertainment center featuring Lego toy displays, rides & a 4-D theater, plus a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-7d2e-70eb-8247-00b420ca3a6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-7d2e-70eb-8247-00b420ca3a6f",
        "storage_key": "property/6767906449167587/019ff6cc-7d2e-70eb-8247-00b420ca3a6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/kansas-city/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=7206990507281059484&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legoland-discovery-center-kansas-city",
      "poi_latitude": "39.08208190000001",
      "poi_longitude": "-94.5813858",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 816-556-3958",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qq6ljwwIcRnI4Znq5fBGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_eadcef27-0617-48f9-ac17-2708b3364d93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Saint Luke's Hospital of Kansas City",
      "poi_type": "Health and Wellness",
      "poi_address": "4401 Wornall Rd, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-5c40-7189-bc5f-b5572b5b6858.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-5c40-7189-bc5f-b5572b5b6858",
        "storage_key": "property/6767906449167587/019fc921-5c40-7189-bc5f-b5572b5b6858.webp",
        "width": 1280,
        "height": 937
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-hospital-kansas-city?utm_source=yext&utm_medium=local_listing&utm_campaign=yext_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4012580085298393479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-hospital-of-kansas-city",
      "poi_latitude": "39.0460972",
      "poi_longitude": "-94.58992940000002",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-932-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-73c9-702b-870f-02095a149881.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-73c9-702b-870f-02095a149881",
        "storage_key": "property/6767906449167587/019fc921-73c9-702b-870f-02095a149881.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJembMcTvwIcRh3EE-VOMrzc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_8ec75b07-4871-481b-beb6-4c8a3450fc58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Saint Luke's Perryman Primary Care-Plaza",
      "poi_type": "Health and Wellness",
      "poi_address": "4321 Washington St ste 3000, Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-5447-7726-b379-ef597d7b726d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-5447-7726-b379-ef597d7b726d",
        "storage_key": "property/6767906449167587/01a0101f-5447-7726-b379-ef597d7b726d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-perryman-primary-care-plaza?utm_source=yext&utm_medium=local_listing&utm_campaign=yext_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4343663036442505921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-perryman-primary-care-plaza",
      "poi_latitude": "39.0481556",
      "poi_longitude": "-94.5914105",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 816-932-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn1CsYs_vwIcRwXIml4TKRzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_b7af3e13-2490-4c61-8d63-141d40c8e6e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "MOJO Cycling Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "4722 Broadway Blvd #220, Kansas City, MO 64112, USA",
      "poi_short_description": "Relaxed cycle studio (and occasional pop-up fitness center), with instructors leading full-body workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-5495-7290-96de-95ff11764815.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-5495-7290-96de-95ff11764815",
        "storage_key": "property/6767906449167587/01a0101f-5495-7290-96de-95ff11764815.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mojocyclingstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16145744172794144761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mojo-cycling-studio",
      "poi_latitude": "39.0416534",
      "poi_longitude": "-94.5917783",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 816-561-1995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_vDaLjvwIcR-We6Bcg0EeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_97ce42fd-a9e8-491b-86be-de3e8a0a3874",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "CorePower Yoga - Country Club Plaza",
      "poi_type": "Health and Wellness",
      "poi_address": "4725 Wyandotte St, Kansas City, MO 64112, USA",
      "poi_short_description": "Chain studio offering physically demanding yoga classes in a variety of styles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-8199-772b-861a-a2b48e43f34d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-8199-772b-861a-a2b48e43f34d",
        "storage_key": "property/6767906449167587/019ff6cc-8199-772b-861a-a2b48e43f34d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/mo/kansas-city/country-club-plaza",
      "poi_directions_map_url": "https://maps.google.com/?cid=14655515030266639755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---country-club-plaza",
      "poi_latitude": "39.0413974",
      "poi_longitude": "-94.5887442",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-716f-77bd-a20c-2d7e6781705c",
        "storage_key": "property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx7wA0bjvwIcRi_Vwk0XZYss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_d889974f-9599-4871-8a8b-25509563b5bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "The Foundation Westport 24hr Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "3800 Summit St, Kansas City, MO 64111, USA",
      "poi_short_description": "Three-level gym with 24/7 access and modern equipment that's divided by workout style.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-5b47-77cf-bf21-e8301ab3318b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-5b47-77cf-bf21-e8301ab3318b",
        "storage_key": "property/6767906449167587/01a0101f-5b47-77cf-bf21-e8301ab3318b.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://tfgyms.com/westport",
      "poi_directions_map_url": "https://maps.google.com/?cid=4318151019755605013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-foundation-westport-24hr-gym",
      "poi_latitude": "39.0579215",
      "poi_longitude": "-94.5958745",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-702-1010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS2hMELbvwIcRFQwGU3kn7Ts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1838e1ad-f83a-428b-b0fd-c05f273cecff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "CrossFit Matters",
      "poi_type": "Health and Wellness",
      "poi_address": "735 Southwest Blvd, Kansas City, KS 66103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-6002-75ac-b56c-111a3289982e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-6002-75ac-b56c-111a3289982e",
        "storage_key": "property/6767906449167587/01a0101f-6002-75ac-b56c-111a3289982e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crossfitmatters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4221749401685879680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossfit-matters",
      "poi_latitude": "39.0629767",
      "poi_longitude": "-94.6185311",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-948-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT5U-fMnvwIcRgGs0iraqljo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7dfa3a89-d112-4580-9387-82f9b1490f8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Power Life Yoga Barre Fitness - South Plaza",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 Main St Ste G003, Kansas City, MO 64112, USA",
      "poi_short_description": "Fitness chain offering yoga, Pilates, barre, and sculpting classes, plus training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-55e1-7798-af1e-ed909a3ee640.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-55e1-7798-af1e-ed909a3ee640",
        "storage_key": "property/6767906449167587/01a0101f-55e1-7798-af1e-ed909a3ee640.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://powerlife.com/location/south-plaza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15250793803416611395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "power-life-yoga-barre-fitness---south-plaza",
      "poi_latitude": "39.0392193",
      "poi_longitude": "-94.5879346",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-541-3793",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOwpdsb7vwIcRQypgeym0pdM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_9e845cb4-75db-4f9f-ac2d-67b4f3468a76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Yoga Patch",
      "poi_type": "Health and Wellness",
      "poi_address": "7235 Central St, Kansas City, MO 64114, USA",
      "poi_short_description": "Relaxed space featuring a variety of classes yoga and meditation, plus a cafe and shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-5895-740c-b46f-71b1858f21a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-5895-740c-b46f-71b1858f21a7",
        "storage_key": "property/6767906449167587/01a0101f-5895-740c-b46f-71b1858f21a7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.yogapatch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5225178224266188267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoga-patch",
      "poi_latitude": "38.99638470000001",
      "poi_longitude": "-94.5925075",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-268-4660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-716f-77bd-a20c-2d7e6781705c",
        "storage_key": "property/6767906449167587/019fc921-716f-77bd-a20c-2d7e6781705c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnTZN1iLvwIcR6xV-KemPg0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_9524bbca-944d-455b-928e-f325b128be7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "The Ewing and Muriel Kauffman Memorial Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4800 Rockhill Rd, Kansas City, MO 64110, USA",
      "poi_short_description": "Spacious burial site of the namesake philanthropists landscaped with fountains, sculptures & paths.",
      "poi_long_description": "Spacious burial site of the namesake philanthropists landscaped with fountains, sculptures & paths.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-62dc-7095-b2e5-0b930965b5f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-62dc-7095-b2e5-0b930965b5f9",
        "storage_key": "property/6767906449167587/019fc921-62dc-7095-b2e5-0b930965b5f9.webp",
        "width": 1280,
        "height": 883
      },
      "poi_business_url": "https://www.kauffman.org/our-campus/memorial-garden/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14397203162452341625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ewing-and-muriel-kauffman-memorial-garden",
      "poi_latitude": "39.0397126",
      "poi_longitude": "-94.5792114",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-932-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxVGPFZTvwIcReTMaIf8jzcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_850dbe57-b316-4795-9dde-97d813cd9b40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Loose Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5200 Wornall Rd, Kansas City, MO 64112, USA",
      "poi_short_description": "Site of a Civil War battle, this 75-acre green space features a pond, tennis courts & a rose garden.",
      "poi_long_description": "Site of a Civil War battle, this 75-acre green space features a pond, tennis courts & a rose garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91e-70a3-775a-9e3b-c380232024b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91e-70a3-775a-9e3b-c380232024b2",
        "storage_key": "property/6767906449167587/019fc91e-70a3-775a-9e3b-c380232024b2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kcparks.org/park/loose-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11009609457171665569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loose-park",
      "poi_latitude": "39.0313445",
      "poi_longitude": "-94.5944237",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-b2b4c2519f56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-b2b4c2519f56",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-b2b4c2519f56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUf-8Na_vwIcRoZJ_Snj9yZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_157d1144-2223-4c5d-9a32-22c94857441c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Penn Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "West 29th Street, Broadway Blvd, Kansas City, MO 64108, USA",
      "poi_short_description": "Park with the National WWI Museum & Memorial, a theater & tennis, baseball & skateboarding venues.",
      "poi_long_description": "Park with the National WWI Museum & Memorial, a theater & tennis, baseball & skateboarding venues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91e-9fe7-7798-8bb2-5436f4c44e47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91e-9fe7-7798-8bb2-5436f4c44e47",
        "storage_key": "property/6767906449167587/019fc91e-9fe7-7798-8bb2-5436f4c44e47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/penn-valley-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15561286278733833014&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-valley-park",
      "poi_latitude": "39.0757432",
      "poi_longitude": "-94.588766",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 816-513-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-b2b4c2519f56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-b2b4c2519f56",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-b2b4c2519f56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYcMmnDvwwIcRNiMXXGzL9Nc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_4db3367c-4c07-49c0-a760-aa82c7d72efe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Fountain in Mill Creek Park",
      "poi_type": "Entertainment",
      "poi_address": "47th Mill Creek Pkwy, Kansas City, MO 64111, USA",
      "poi_short_description": "A popular photo op, this illuminated fountain in the city center is surrounded by benches.",
      "poi_long_description": "A popular photo op, this illuminated fountain in the city center is surrounded by benches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-8259-74d4-bad8-060cf6dc7486.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-8259-74d4-bad8-060cf6dc7486",
        "storage_key": "property/6767906449167587/019ff6cc-8259-74d4-bad8-060cf6dc7486.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kcparks.org/places/fountain-millcreek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16120696377665005746&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fountain-in-mill-creek-park",
      "poi_latitude": "39.0426122",
      "poi_longitude": "-94.5875336",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 816-842-2299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSaThRb_vwIcRsiimwvE3uN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fountain"
    },
    {
      "id": "custom_45c03a2d-7ffe-4721-a97d-756a56fed6ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Brookside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5600 Brookside Blvd, Kansas City, MO 64113, USA",
      "poi_short_description": "City park offering recreational activities such as tennis, volleyball, and sledding, as well as a kids' playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-5d50-7115-8bdd-a673e4667aa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-5d50-7115-8bdd-a673e4667aa7",
        "storage_key": "property/6767906449167587/01a0101f-5d50-7115-8bdd-a673e4667aa7.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://kcparks.org/places/brookside-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12275546699541465645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brookside-park",
      "poi_latitude": "39.0251348",
      "poi_longitude": "-94.5853365",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 816-513-7503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7178-77d4-9b68-b2b4c2519f56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7178-77d4-9b68-b2b4c2519f56",
        "storage_key": "property/6767906449167587/019fc921-7178-77d4-9b68-b2b4c2519f56.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3-MNUKDvwIcRLUrjQa-AW6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_dc0d27b8-284c-4760-bc79-e0cce132658c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Buzzard Beach",
      "poi_type": "Restaurants",
      "poi_address": "4110 Pennsylvania Ave, Kansas City, MO 64111, USA",
      "poi_short_description": "Pool table-filled dive bar with arcade games, skateboard decor and a patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-59ac-708e-8fcb-3e5ae1a9ce61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-59ac-708e-8fcb-3e5ae1a9ce61",
        "storage_key": "property/6767906449167587/01a0101f-59ac-708e-8fcb-3e5ae1a9ce61.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=792494118597320080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buzzard-beach",
      "poi_latitude": "39.0521563",
      "poi_longitude": "-94.5915676",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 816-300-2899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-714f-7708-ac60-ef4e8b9c96ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-714f-7708-ac60-ef4e8b9c96ef",
        "storage_key": "property/6767906449167587/019fc921-714f-7708-ac60-ef4e8b9c96ef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ77KLGcXvwIcRkF2UuTOB_wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_933c5d05-6dcb-4353-8222-f9be922bc5da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "On 39th at Main Westbound",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64111, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14043194144653827335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-39th-at-main-westbound",
      "poi_latitude": "39.056635",
      "poi_longitude": "-94.58599",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-9af5-749c-adc4-3a4bd8c3f75a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6cc-9af5-749c-adc4-3a4bd8c3f75a",
        "storage_key": "property/6767906449167587/019ff6cc-9af5-749c-adc4-3a4bd8c3f75a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2yEOVtzvwIcRB93vp6ty48I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_f01bccfe-5e10-4740-885f-d687b1036ab1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Kansas City 47Th St Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, KS 66102, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15986244376617175594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-47th-st-transit-center",
      "poi_latitude": "39.11365",
      "poi_longitude": "-94.68587",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-9af5-749c-adc4-3a4bd8c3f75a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6cc-9af5-749c-adc4-3a4bd8c3f75a",
        "storage_key": "property/6767906449167587/019ff6cc-9af5-749c-adc4-3a4bd8c3f75a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJESfn8qfzwIcRKkra0I-M2t0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_dc1e3884-a4af-4551-84ee-aaa34abe5f01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Metro Center (12th & Main St)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-89c7-747e-b762-475a3befaa33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-89c7-747e-b762-475a3befaa33",
        "storage_key": "property/6767906449167587/019ff6cc-89c7-747e-b762-475a3befaa33.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://ridekc.org/assets/uploads/route-maps/Streetcarmwk.jpg",
      "poi_directions_map_url": "https://maps.google.com/?cid=13899610975165952526&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metro-center-12th--main-st",
      "poi_latitude": "39.099829",
      "poi_longitude": "-94.583256",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-9af5-749c-adc4-3a4bd8c3f75a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6cc-9af5-749c-adc4-3a4bd8c3f75a",
        "storage_key": "property/6767906449167587/019ff6cc-9af5-749c-adc4-3a4bd8c3f75a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJQS3Y9F3wwIcRDjLj4olW5cA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tram_stop"
    },
    {
      "id": "custom_44f71783-e4a5-41a9-a77f-45c9ff38fa4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1101 Troost Ave, Kansas City, MO 64106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-5ade-718a-8daf-508757aa33b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-5ade-718a-8daf-508757aa33b6",
        "storage_key": "property/6767906449167587/01a0101f-5ade-718a-8daf-508757aa33b6.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/kansas-city-mo/kansas-city-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16685443334022975407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "39.1000335",
      "poi_longitude": "-94.5693013",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWy-YvXvwwIcRr09ZHE-ajuc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_08fdae97-e236-4a7a-aebb-fc8605e5ac37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Kansas City",
      "poi_type": "Transportation & Transit",
      "poi_address": "30 W Pershing Rd Union Station, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91f-37d2-70df-b3d2-a394b7d591af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91f-37d2-70df-b3d2-a394b7d591af",
        "storage_key": "property/6767906449167587/019fc91f-37d2-70df-b3d2-a394b7d591af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=KCY",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787247529242741214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city",
      "poi_latitude": "39.0847966",
      "poi_longitude": "-94.5853578",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6c8-9b78-73dd-b4f3-bf8fe7dfcd68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6c8-9b78-73dd-b4f3-bf8fe7dfcd68",
        "storage_key": "property/6767906449167587/019ff6c8-9b78-73dd-b4f3-bf8fe7dfcd68.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbu2nD_wwIcR3kn96I8BjzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_ddb96602-7269-402b-bb15-9e2a7f8975d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-88e1-7059-ba20-689f80e5ec5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-88e1-7059-ba20-689f80e5ec5c",
        "storage_key": "property/6767906449167587/019ff6cc-88e1-7059-ba20-689f80e5ec5c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3014091",
      "poi_longitude": "-94.7104536",
      "poi_miles_from_property": "25.2",
      "poi_walking_minutes": "9 hours 25 mins",
      "poi_biking_minutes": "3 hours 6 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6c8-9b65-76ce-ac31-437fb61e09dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6c8-9b65-76ce-ac31-437fb61e09dd",
        "storage_key": "property/6767906449167587/019ff6c8-9b65-76ce-ac31-437fb61e09dd.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_891edf5c-9fbe-4648-9e7d-4315f6fd1bfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Children's Mercy Adele Hall Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "2401 Gillham Rd, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91e-6a56-73c9-9c6a-c99d1c3892db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91e-6a56-73c9-9c6a-c99d1c3892db",
        "storage_key": "property/6767906449167587/019fc91e-6a56-73c9-9c6a-c99d1c3892db.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.childrensmercy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=241680805565643787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-adele-hall-campus",
      "poi_latitude": "39.08387889999999",
      "poi_longitude": "-94.5771759",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-234-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-73c9-702b-870f-02095a149881.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-73c9-702b-870f-02095a149881",
        "storage_key": "property/6767906449167587/019fc921-73c9-702b-870f-02095a149881.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zZsZRPwwIcRCzzFhGmfWgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1ac6c553-fd9b-418f-a2ee-641ce3d9fddc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "University Health Truman Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 Holmes St, Kansas City, MO 64108, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-6287-75eb-b9da-304633a047f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-6287-75eb-b9da-304633a047f0",
        "storage_key": "property/6767906449167587/019fc921-6287-75eb-b9da-304633a047f0.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.universityhealthkc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3094198644431175220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-health-truman-medical-center",
      "poi_latitude": "39.0841581",
      "poi_longitude": "-94.5752125",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 816-404-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-73c9-702b-870f-02095a149881.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-73c9-702b-870f-02095a149881",
        "storage_key": "property/6767906449167587/019fc921-73c9-702b-870f-02095a149881.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJidv_PG3wwIcRNL7Q-UXN8Co",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_96172b37-7d29-43a4-875e-057d0afc1b07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "H&R Block",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One H and R, Block Way, Kansas City, MO 64105, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-63c2-7516-83f1-a96065c72024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc921-63c2-7516-83f1-a96065c72024",
        "storage_key": "property/6767906449167587/019fc921-63c2-7516-83f1-a96065c72024.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hrblock.com/tax-offices/local/missouri-tax-preparation/kansas-city-tax-professionals/?otppartnerid=9308&campaignid=pw_mcm_9308_9762&utm_medium=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17520317420083081084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hr-block",
      "poi_latitude": "39.0982642",
      "poi_longitude": "-94.5829906",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 816-854-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8i63JCKwIcRfO8j8N2rJPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_3eb0db86-5c76-4da9-833c-d7e844b1e40c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Hallmark Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 McGee St, Kansas City, MO 64108, USA",
      "poi_short_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_long_description": "Retail chain specializing in greeting cards, gift wrap, ornaments & gifts for all occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc91e-cb45-767f-82f7-91a0369509cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91e-cb45-767f-82f7-91a0369509cb",
        "storage_key": "property/6767906449167587/019fc91e-cb45-767f-82f7-91a0369509cb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://corporate.hallmark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1199437302719612463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hallmark-corporate",
      "poi_latitude": "39.0811114",
      "poi_longitude": "-94.5800029",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-425-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzp5phbwwIcRL4b0Nt9BpRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_669c8bfc-d087-4aac-bc23-235fcfe327e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Cerner Corporation - World Headquarters Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2800 Rock Creek Pkwy, Kansas City, MO 64117, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019ff6cc-8d69-73ee-9567-7640a415d998.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cc-8d69-73ee-9567-7640a415d998",
        "storage_key": "property/6767906449167587/019ff6cc-8d69-73ee-9567-7640a415d998.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.cerner.com/?utm_source=google&utm_medium=organic&utm_campaign=organic-local-listings&utm_content=whq-campus",
      "poi_directions_map_url": "https://maps.google.com/?cid=1107266875381616454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cerner-corporation---world-headquarters-campus",
      "poi_latitude": "39.14986409999999",
      "poi_longitude": "-94.5459231",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 816-221-1024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-7173-72bc-ab4c-076d45702d5d",
        "storage_key": "property/6767906449167587/019fc921-7173-72bc-ab4c-076d45702d5d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncA2l_X5wIcRRo-tSlvNXQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_616103fe-a3a4-4074-b77f-ca4590d56815",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "custom",
      "poi_name": "Kansas City VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "4801 Linwood Blvd, Kansas City, MO 64128, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a0101f-629c-73b0-9c62-1419454c9198.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0101f-629c-73b0-9c62-1419454c9198",
        "storage_key": "property/6767906449167587/01a0101f-629c-73b0-9c62-1419454c9198.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.va.gov/kansas-city-health-care/locations/kansas-city-va-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5799742172005804653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-va-medical-center",
      "poi_latitude": "39.0633775",
      "poi_longitude": "-94.5269583",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 816-861-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/019fc921-73c9-702b-870f-02095a149881.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc921-73c9-702b-870f-02095a149881",
        "storage_key": "property/6767906449167587/019fc921-73c9-702b-870f-02095a149881.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZG7XSzlwIcRbSpC78bSfFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a62391dbf8f4afbb688b047c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c389f8666970894bd799ef2d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_9c57427409da41ee30ecf0a7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_628f93c30896314910be0e5f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f197daf9b01cf421d0bc8931",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_5923347933dc37ea4800c0be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_98b93ff60fbe30f298830cfc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "rating": "5",
      "name": "Skyelar Nelson",
      "text": "46 Penn has been the perfect first post-grad apartment for me and I couldn't recommend it more! As a PA student, having a comfortable place to live and study is really important, and the staff here has been amazing and is always extremely attentive to resident requests. The maintenance team is incredibly fast, typically responding to requests day of and communicating in detail what work was done. The management team even installed a whiteboard for me and my best friend/neighbor/PA student Kennedy in the study room so we could write out our lectures. It might seem like a small gesture, but it made such a difference for us and is a testament to how much the staff cares for each resident in the building. I’m really grateful to live somewhere with such responsive staff and a great environment! :) Plus it's walking distance to great food and shopping on the plaza!",
      "date": "2026-03-11",
      "title": "false"
    },
    {
      "id": "ec_db1b0144f5ceb24635f8c8f2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "rating": "5",
      "name": "Marie Fanfan",
      "text": "I am  so happy for my apartment! Mia and Kierra are amazing and it is so beautiful here. My son and I are very happy thank you Mia!!",
      "date": "2026-06-18",
      "title": "false"
    },
    {
      "id": "ec_578f9b6d05944a25b175a8b7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "rating": "5",
      "name": "Marissa Kunerth",
      "text": "I’ve been a resident at 46 Penn for a few months now, and I can’t speak highly enough of the apartment building and its management team. My boyfriend and I relocated to KC from out of state and had originally signed a lease at a nearby building, sight unseen. Due to some unexpected issues with that unit at move-in, we were suddenly in a rush to find a new place. Jason and the team at 46 Penn were incredibly accommodating on short notice and helped us find a great place. We love the building’s amenities, fun community events, quiet atmosphere, safe parking, and convenient location.",
      "date": "2025-10-16",
      "title": "false"
    },
    {
      "id": "ec_6decca98ef6982495220a389",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "rating": "5",
      "name": "Qiyang Lian",
      "text": "I moved to 46 Penn in 2021 from another property managed by the same company. While I initially faced noise issues similar to my previous building (loud music, dog barking, etc.), the management was incredibly accommodating and allowed me to transfer to a top-floor unit, which resolved the problem entirely. I personally haven't experienced the security issues some others have reported, and I'm aware of the significant improvements the management has implemented over the past four years. My packages were always signed and securely stored. They're very responsive to maintenance requests and frequently organize community events, which many residents seem to enjoy. Overall, I was very satisfied with my living experience here and only moved due to an out-of-state job.",
      "date": "2025-07-17",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_d041d23ca7998123111701da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-6074-7079-9d3c-d961cea03d9b.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01019-6074-7079-9d3c-d961cea03d9b",
        "storage_key": "property/6767906449167587/01a01019-6074-7079-9d3c-d961cea03d9b.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JsWPm7PHHA6"
    },
    {
      "id": "ec_d9adef206842e111e63de46d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "46 Penn Apartments - A2 - 1 bed, 1 bath, 722 sqft.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-6077-77ce-b291-8103f4c5d874.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01019-6077-77ce-b291-8103f4c5d874",
        "storage_key": "property/6767906449167587/01a01019-6077-77ce-b291-8103f4c5d874.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Q8AjQufkiLV"
    },
    {
      "id": "ec_26570b72e85b67564346c738",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-607a-70c0-8943-2324784c81aa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01019-607a-70c0-8943-2324784c81aa",
        "storage_key": "property/6767906449167587/01a01019-607a-70c0-8943-2324784c81aa.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A3",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vzmuju5C7cn"
    },
    {
      "id": "ec_757862b4f5e721be72550441",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-6135-7119-ba06-2c9fdf69701e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01019-6135-7119-ba06-2c9fdf69701e",
        "storage_key": "property/6767906449167587/01a01019-6135-7119-ba06-2c9fdf69701e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A4",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PaF69ARUGqT"
    },
    {
      "id": "ec_58fe02435e158fed6da65626",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-6298-75b8-a8ba-876cb620efef.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01019-6298-75b8-a8ba-876cb620efef",
        "storage_key": "property/6767906449167587/01a01019-6298-75b8-a8ba-876cb620efef.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5zhi31m4FDj"
    },
    {
      "id": "ec_1263455d853dd8d29e0fa7f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-68c3-717c-b561-b6c1e2dcc61a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01019-68c3-717c-b561-b6c1e2dcc61a",
        "storage_key": "property/6767906449167587/01a01019-68c3-717c-b561-b6c1e2dcc61a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JDk2pBMohzD"
    },
    {
      "id": "ec_c5f11007cb6a2002a2d55061",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-68a3-7424-ab63-3d4e81bdbdfc.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01019-68a3-7424-ab63-3d4e81bdbdfc",
        "storage_key": "property/6767906449167587/01a01019-68a3-7424-ab63-3d4e81bdbdfc.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B3",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AU7isMz3nUv"
    },
    {
      "id": "ec_4ad809e0394cc120157fe521",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-69cf-709b-84de-a3d9bb89cbe1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01019-69cf-709b-84de-a3d9bb89cbe1",
        "storage_key": "property/6767906449167587/01a01019-69cf-709b-84de-a3d9bb89cbe1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B4",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=r9kXr9VvG7D"
    },
    {
      "id": "ec_53bf1ef7077bea13ce647113",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-686c-756f-b532-c5f98b28a75f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01019-686c-756f-b532-c5f98b28a75f",
        "storage_key": "property/6767906449167587/01a01019-686c-756f-b532-c5f98b28a75f.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B5",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=57c5cCSK8bX"
    },
    {
      "id": "ec_7185478b66d09db849eb3f25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167587/01a01019-6990-7428-a96b-b26c050d482d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a01019-6990-7428-a96b-b26c050d482d",
        "storage_key": "property/6767906449167587/01a01019-6990-7428-a96b-b26c050d482d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B6",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BsfgCJUaKcA"
    }
  ],
  "faqs": [
    {
      "id": "custom_21b69ac6-88af-49e4-a1fe-9edf3696d062",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_7b9b4a35-882a-4548-97e9-9486e07337bf",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_ba9a59e7-0c86-4c18-bbe7-2ac7cc85b278",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours Monday through Friday. However, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions.  Saturday tours are by appointment only.\n\nIt is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, or Passport.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_cb0e8fb9-0c11-4770-9333-ec695a8ace44",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_619cf5aa-448d-4841-9334-b1b1141a96d3",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_22dce9df-cf95-4869-b123-01f4cda1cc2e",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_e4484b0f-113c-4011-a91d-02bef905b0d8",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7d7abe7a-c645-4546-bc2e-f2a176307d78",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A “holding” deposit or “earnest money” is another word for “security” deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_69587062-a2d4-49a4-8a71-924928456ebc",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_4d7bee16-6ff0-4b7f-9f3a-4e0e8402897f",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "General",
      "source": "custom"
    },
    {
      "id": "custom_044cb234-d601-454d-ac29-ae4ae5b2672d",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_19f93188-1855-4b22-9ea0-eff2af701798",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_7a90e804-ad92-466a-b760-1a799bc5615b",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer a parking garage that includes 1 assigned space for 1 bedroom apartment homes and 2 assigned spaces for 2 bedroom apartment homes. Additional garage parking spaces may be available for rent. Please <a href=\"/contact-us\">contact the office</a> for our most current availability and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_4d9df6ec-d87e-4074-a6b2-0762f91c4a40",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_6a7516f6-6cf1-47a3-beee-a99894f57b77",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "Yes, if you are not home to accept a package it can be left at the clubhouse for you to pick up. We please ask that you pick it up as soon as possible to prevent overcrowding.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_03bd6325-eaa5-48a3-bc52-e8a9786e2d2f",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-2b08-705c-877c-6116583f5b03",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "46 Penn Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587"
    },
    {
      "lead_collector_id": "01a0c9ac-2bfe-7148-80c5-ff9f4e39ca3c",
      "lead_source": "LANDING_PAGE",
      "name": "46 Penn Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "pool-apartments-kansas-city-mo",
      "search_query": "pool apartments Kansas City MO",
      "category": "Amenity",
      "h1_title": "Pool Apartments in Kansas City, MO",
      "h2_subtitle": "Discover poolside living in Kansas City, MO. Our community offers luxurious amenities like a pool and connected conveniences.",
      "page_copy": "Looking for pool apartments in Kansas City, MO? 46 Penn Apartment Homes offers you a blend of urban momentum with luxurious amenities, including an inviting pool area. Located in the heart of Midtown – Westport, our community is designed for comfort and convenience. Choose from our spacious one- and two-bedroom layouts, each featuring polished finishes and hardwood floors.\n\nDive into resort-style living with access to a sparkling pool, high-speed internet, and a modern clubhouse. Whether you're commuting or enjoying the vibrant community, you'll appreciate the connectivity and ease of living here. Experience the best of Kansas City from a prime location that feels both lively and serene. Explore 46 Penn Apartment Homes today and enjoy all the charm and amenities you desire.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool Apartments in Kansas City, MO",
      "seo_description": "Explore pool apartments in Kansas City, MO at 46 Penn Apartment Homes. Enjoy urban living with resort-style amenities like a pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-fitness-center-jackson-county",
      "search_query": "luxury apartments with fitness center in Jackson County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center",
      "h2_subtitle": "Experience luxury living in Jackson County. Our apartments feature a modern fitness center among many premium amenities.",
      "page_copy": "Searching for luxury apartments with a fitness center in Jackson County? Discover the elegance of 46 Penn Apartment Homes, where style meets functionality. Nestled in the vibrant Midtown – Westport area, our community offers more than just a place to live; it offers a lifestyle.\n\nEnjoy unrivaled amenities like a state-of-the-art fitness center, perfect for your active lifestyle. Our one- and two-bedroom apartments are designed with exquisite finishes and conveniences, such as high-speed internet access and a charming pool. Whether you're unwinding in the clubhouse or staying fit, 46 Penn provides a premier living experience in Kansas City, MO.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center",
      "seo_description": "Discover luxury apartments with a fitness center at 46 Penn in Jackson County. Experience upscale living in Kansas City, MO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "apartments-with-private-parking-midtown-westport",
      "search_query": "apartments with private parking Midtown Westport",
      "category": "Amenity",
      "h1_title": "Apartments with Private Parking",
      "h2_subtitle": "Find your dream apartment with private parking in Midtown – Westport. Our Kansas City homes offer convenience and contemporary amenities.",
      "page_copy": "Discover the convenience of apartments with private parking in Midtown – Westport. At 46 Penn Apartment Homes, we provide exclusive parking options that make city living more manageable and stress-free. This prime location in the heart of Kansas City, MO, ensures that you’re never far from the action. \n\nOur one- and two-bedroom apartments are crafted with polished finishes and feature a range of luxury amenities. Enjoy high-speed internet, a community pool, and a welcoming clubhouse. 46 Penn is dedicated to providing an elevated living experience, combining comfort with the vibrancy of Midtown – Westport’s bustling environment. Experience unmatched convenience and style in our thoughtfully designed living spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Private Parking",
      "seo_description": "Explore apartments with private parking at 46 Penn in Midtown – Westport. Enjoy convenience and top-notch amenities in Kansas City, MO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "kansas-city-apartments-concierge-services",
      "search_query": "Kansas City apartments with concierge services",
      "category": "Amenity",
      "h1_title": "Kansas City Apartments with Concierge",
      "h2_subtitle": "Experience the ease of concierge services in Kansas City. Our community offers upscale living and personalized assistance.",
      "page_copy": "If you're searching for Kansas City apartments with concierge services, consider 46 Penn Apartment Homes. While we focus on delivering unmatched comfort, our community undeniably exudes a sense of luxury living. Situated in Midtown – Westport, our location offers both vibrancy and tranquility, ideal for a modern lifestyle.\n\nOur spacious one- and two-bedroom layouts are equipped with premium amenities like high-speed internet, a refreshing pool, and stylish hardwood floors. Experience the best of Kansas City living, where each feature is designed with your convenience and satisfaction in mind. While our property emphasizes privacy and comfort, our dedicated service makes a lasting impression.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kansas City Apartments with Concierge",
      "seo_description": "Explore Kansas City apartments with concierge-style services at 46 Penn. Enjoy luxury living and personalized amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-near-64111",
      "search_query": "in-unit laundry apartments near 64111",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments Nearby",
      "h2_subtitle": "Enjoy in-unit laundry convenience near 64111. Discover modern apartment living in Kansas City's lively neighborhoods.",
      "page_copy": "For those seeking in-unit laundry apartments near 64111, 46 Penn Apartment Homes offers the perfect blend of modern convenience and upscale living. Located in the dynamic Midtown – Westport area of Kansas City, our apartments cater to your every need.\n\nEach one- and two-bedroom apartment is thoughtfully designed with polished finishes and contemporary amenities, including high-speed internet access, hardwood floors, and a sparkling swimming pool. Our community ensures a comfortable and efficient lifestyle, allowing you to experience the best that Kansas City's sought-after neighborhood has to offer—all while enjoying the ease of in-unit laundry.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments Nearby",
      "seo_description": "Explore in-unit laundry apartments near 64111 at 46 Penn. Enjoy modern amenities in Kansas City's Midtown – Westport area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-midtown-westport-kansas-city",
      "search_query": "1 bedroom apartments midtown westport kansas city",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Midtown KC",
      "h2_subtitle": "Discover 1 bedroom apartments in Midtown Westport, Kansas City. Experience modern living with exceptional convenience.",
      "page_copy": "Explore 46 Penn Apartment Homes, where our 1 bedroom apartments in Midtown Westport, Kansas City, offer a refined living experience. Nestled in a vibrant neighborhood, our homes combine contemporary design with functionality, making them ideal for today's lifestyle.\n\nOur apartments feature high-quality finishes, like hardwood floors and state-of-the-art appliances. Enjoy amenities that enhance your living experience, such as high-speed internet access, a serene pool, and a fun-filled clubhouse. Located in the heart of Kansas City, these apartments provide the perfect balance of urban excitement and residential comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Midtown KC",
      "seo_description": "Discover 1 bedroom apartments in Midtown Westport, Kansas City, at 46 Penn. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-jackson-county-mo",
      "search_query": "2 bedroom apartments jackson county mo",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Jackson County",
      "h2_subtitle": "Find spacious 2 bedroom apartments in Jackson County, MO, offering luxury and convenience in the heart of Kansas City.",
      "page_copy": "If you're on the hunt for 2 bedroom apartments in Jackson County, MO, look no further than 46 Penn Apartment Homes. Our community promises spacious and beautifully-appointed apartments that cater to those who appreciate both style and practicality. \n\nSituated in the energetic Midtown – Westport area, our homes offer easy access to Kansas City's amenities. Inside, enjoy polished hardwood floors, a comprehensive kitchen with an oven, and high-speed internet access. Added conveniences like a sparkling pool and a welcoming clubhouse complete the experience, ensuring our residents live comfortably and luxuriously in Jackson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Jackson County",
      "seo_description": "Explore spacious 2 bedroom apartments in Jackson County, MO at 46 Penn, offering comfort and style in the heart of Kansas City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-missouri-kansas-city",
      "search_query": "apartments near University of Missouri-Kansas City",
      "category": "School",
      "h1_title": "Apartments Near University of Missouri-KC",
      "h2_subtitle": "Discover convenient apartments near University of Missouri-Kansas City. Enjoy modern living and easy access to campus amenities.",
      "page_copy": "At 46 Penn Apartment Homes, we offer ideal living accommodations near the University of Missouri-Kansas City. Perfectly situated in the lively Midtown – Westport area, our community provides the best of city life and student convenience.\n\nOur apartments come with high-end features like hardwood floors, high-speed internet, and full kitchens equipped with ovens. Residents can unwind in our relaxed pool area or socialize in the clubhouse, making it easy to strike a balance between academic and personal life. Experience comfort, convenience, and community just minutes from the University of Missouri-Kansas City campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Missouri-KC",
      "seo_description": "Find modern apartments near University of Missouri-Kansas City at 46 Penn, featuring great amenities and student-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "46-penn-apartment-homes-close-to-rockhurst-university",
      "search_query": "46 Penn Apartment Homes close to Rockhurst University",
      "category": "School",
      "h1_title": "46 Penn Apartment Homes Close to Rockhurst",
      "h2_subtitle": "Explore 46 Penn Apartment Homes, conveniently located near Rockhurst University, offering modern amenities and vibrant community living.",
      "page_copy": "Situated conveniently close to Rockhurst University, 46 Penn Apartment Homes offers scholars and professionals a refined living experience in Kansas City. Set in the bustling Midtown – Westport neighborhood, our apartments provide the perfect intersection of modern design and daily convenience.\n\nEach apartment boasts stylish hardwood floors, sleek kitchens with full ovens, and reliable high-speed internet access. Enjoy relaxation by the pool or gather with friends in our welcoming clubhouse. Whether you're heading to class or exploring the local scene, 46 Penn Apartment Homes promises an enriching lifestyle near Rockhurst University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "46 Penn Homes Close to Rockhurst University",
      "seo_description": "Discover 46 Penn Apartment Homes near Rockhurst University, offering stylish living in a vibrant community with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "kansas-city-apartments-near-art-institute",
      "search_query": "Kansas City apartments near Kansas City Art Institute",
      "category": "School",
      "h1_title": "KC Apartments Near Art Institute",
      "h2_subtitle": "Discover Kansas City apartments near the Kansas City Art Institute, bringing you close to vibrant arts culture and convenient living.",
      "page_copy": "46 Penn Apartment Homes, located in the dynamic Midtown – Westport area, offers uniquely designed apartments that place you just moments away from the Kansas City Art Institute. Our one- and two-bedroom units provide art students and enthusiasts with a stylish living space imbued with comfort.\n\nEnjoy modern amenities like high-speed internet, elegant hardwood flooring, and fully-equipped kitchens. Residences also have access to a serene pool and a sociable clubhouse, ensuring a convenient and connected lifestyle. Embrace Kansas City's lively arts scene with ease from our perfectly positioned apartment community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "KC Apartments Near Art Institute",
      "seo_description": "Experience Kansas City living near the Art Institute at 46 Penn, featuring stylish apartments with modern amenities just steps from vibrant arts culture.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "midtown-westport-apartments-near-paseo-academy",
      "search_query": "Midtown - Westport apartments by Paseo Academy of Fine and Performing Arts",
      "category": "School",
      "h1_title": "Midtown Apartments by Paseo Academy",
      "h2_subtitle": "Explore Midtown Westport apartments near Paseo Academy of Fine and Performing Arts, offering prime locations and excellent amenities.",
      "page_copy": "Located in the heart of Midtown – Westport, 46 Penn Apartment Homes provides premium living spaces near Paseo Academy of Fine and Performing Arts. This community is ideal for those looking to immerse themselves in the vibrant arts scene while enjoying a comfortable home environment.\n\nResidents will love our sleek one- and two-bedroom apartments, complete with hardwood floors, high-speed internet, and modern kitchen amenities. Enjoy leisurely time by the pool or mingle in the inviting clubhouse. Living near Paseo Academy has never been more enjoyable than at 46 Penn, where convenience meets style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown Apartments by Paseo Academy",
      "seo_description": "Find stylish Midtown - Westport apartments near Paseo Academy, offering the best in city living with modern amenities at 46 Penn.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "jackson-county-apartments-near-gordon-parks-school",
      "search_query": "Jackson County apartments near Gordon Parks Elementary School",
      "category": "School",
      "h1_title": "Apartments Near Gordon Parks Elementary",
      "h2_subtitle": "Discover Jackson County apartments conveniently situated near Gordon Parks Elementary School, offering a family-friendly environment.",
      "page_copy": "Located within Jackson County, 46 Penn Apartment Homes offers an ideal blend of convenience and comfort for families and professionals alike. Just a short distance from Gordon Parks Elementary School, our community is perfect for those seeking a nurturing environment close to educational facilities.\n\nOur spacious one- and two-bedroom apartments feature quality finishes like hardwood flooring and modern kitchens, complemented by high-speed internet access. With a pool and clubhouse on-site, residents enjoy both relaxation and social opportunities. Experience the ease of living near Gordon Parks Elementary with a touch of elegance at 46 Penn.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Jackson County Apts Near Gordon Parks Elementary",
      "seo_description": "Explore Jackson County living at 46 Penn, offering apartments near Gordon Parks Elementary with family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "apartments-near-hale-cook-elementary-kansas-city",
      "search_query": "apartments close to Hale Cook Elementary School Kansas City",
      "category": "School",
      "h1_title": "Apartments Near Hale Cook Elementary",
      "h2_subtitle": "Explore Kansas City apartments close to Hale Cook Elementary School, providing convenience and community for families.",
      "page_copy": "46 Penn Apartment Homes, set in the vibrant Midtown – Westport area of Kansas City, boasts spacious living options ideal for families. Being near Hale Cook Elementary School, our community offers convenience for parents and children alike.\n\nOur one- and two-bedroom apartments include features such as beautiful hardwood floors, high-speed internet, and modern kitchen facilities, making them both practical and stylish. Residents also have access to fantastic amenities like a refreshing pool and a welcoming clubhouse. Enjoy a community-focused lifestyle near Hale Cook with 46 Penn's thoughtfully designed spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "KC Apartments Near Hale Cook Elementary",
      "seo_description": "Find family-friendly apartments in Kansas City at 46 Penn, conveniently located near Hale Cook Elementary School.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "midtown-apartments-near-central-high-school-mo",
      "search_query": "Midtown apartments near Central High School MO",
      "category": "School",
      "h1_title": "Midtown Apartments Near Central High School",
      "h2_subtitle": "Discover stylish Midtown apartments near Central High School in MO, offering convenience and modern amenities for all residents.",
      "page_copy": "Located in Kansas City's vibrant Midtown – Westport community, 46 Penn Apartment Homes provides an ideal living space for those looking to be near Central High School, MO. Our location offers a perfect balance of convenience and contemporary living.\n\nResidents can choose from a range of spacious one- and two-bedroom apartments featuring polished hardwood floors, high-speed internet, and modern kitchen appliances. With access to a clubhouse and a refreshing pool, our community fosters both relaxation and socializing opportunities. Experience the ease of living close to Central High School at 46 Penn.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Midtown Apartments Near Central High School, MO",
      "seo_description": "Explore modern Midtown living at 46 Penn, featuring apartments near Central High School, MO with top amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "apartments-near-childrens-mercy-adele-hall-campus",
      "search_query": "apartments near children's mercy adele hall campus kansas city",
      "category": "Hospital",
      "h1_title": "Apartments Near Children's Mercy Adele Hall",
      "h2_subtitle": "Find ideal Kansas City apartments near Children's Mercy Adele Hall Campus, offering comfort and convenience.",
      "page_copy": "46 Penn Apartment Homes is perfectly situated in the heart of Kansas City, making it a prime choice for those seeking apartments near Children's Mercy Adele Hall Campus. Our one- and two-bedroom units provide a haven of comfort and style.\n\nFeaturing polished hardwood floors, modern kitchen appliances, and high-speed internet access, our apartments cater to modern lifestyles. Enjoy the community's vibrant social scene with amenities like a sparkling pool and a spacious clubhouse. Experience convenient living close to Children's Mercy Adele Hall Campus, all within the welcoming community of 46 Penn.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Childrens Mercy Adele Hall in KC",
      "seo_description": "Discover Kansas City living at 46 Penn, featuring apartments near Children's Mercy Adele Hall Campus with top amenities and stylish interiors.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "apartments-near-university-health-truman-medical-center",
      "search_query": "apartments close to university health truman medical center 64111",
      "category": "Hospital",
      "h1_title": "Apts Close to University Health Truman Medical",
      "h2_subtitle": "Live conveniently with apartments close to University Health Truman Medical Center, located in Kansas City, MO 64111.",
      "page_copy": "Located in the bustling Midtown – Westport area, 46 Penn Apartment Homes offers an excellent location for those seeking apartments close to University Health Truman Medical Center in Kansas City, MO. Our community provides the perfect mix of comfort and convenience.\n\nOur spacious one- and two-bedroom apartments come with modern finishes such as hardwood floors, high-speed internet, and contemporary kitchen features. Residents can also unwind in our enticing pool or meet neighbors in our stylish clubhouse. Experience hassle-free living with easy access to healthcare facilities at University Health Truman Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near University Health Truman Medical, KC",
      "seo_description": "Find comfort and convenience at 46 Penn, featuring apartments near University Health Truman Medical Center in Kansas City, MO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-va-medical-center",
      "search_query": "apartments by kansas city va medical center jackson county",
      "category": "Hospital",
      "h1_title": "Apts by Kansas City VA Medical Center, Jackson",
      "h2_subtitle": "Explore apartments conveniently situated near Kansas City VA Medical Center in Jackson County, providing easy access and modern amenities.",
      "page_copy": "In the dynamic Midtown – Westport area, 46 Penn Apartment Homes is an exceptional choice for those searching for apartments near the Kansas City VA Medical Center. Located in Jackson County, our community offers convenience and a stylish living environment.\n\nChoose from our expansive one- and two-bedroom units, complete with hardwood floors, high-speed internet, and top-grade kitchen appliances. Residents can enjoy the community's vibrant atmosphere, with amenities like a swimming pool and a welcoming clubhouse. Discover the ease of living in proximity to Kansas City VA Medical Center at 46 Penn Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts by KC VA Medical Center, Jackson County",
      "seo_description": "46 Penn offers modern apartments near Kansas City VA Medical Center, Jackson County, with top amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167587",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport",
      "category": "Transit",
      "h1_title": "Apts Near Kansas City International Airport",
      "h2_subtitle": "Discover stylish living with apartments near Kansas City International Airport, blending convenience and luxury.",
      "page_copy": "46 Penn Apartment Homes, located in the vibrant Midtown – Westport area, presents an ideal option for those seeking apartments near Kansas City International Airport. Enjoy the convenience of a prime city location with effortless access to both the airport and urban attractions.\n\nOur one- and two-bedroom apartments offer polished finishes, such as hardwood floors and modern kitchen appliances, designed for contemporary lifestyles. Residents can take advantage of amenities including a resort-style pool and a well-appointed clubhouse. Experience the best of city living with easy airport access at 46 Penn.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
      "featured_image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and view of the outdoor pool.",
        "public_id": "01a01018-3830-743f-90a7-c54196405991",
        "storage_key": "property/6767906449167587/01a01018-3830-743f-90a7-c54196405991.webp",
        "width": 1200,
        "height": 800
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Kansas City Intl Airport",
      "seo_description": "Find modern living at 46 Penn, with apartments near Kansas City International Airport, offering top amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701847496"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WSGTTQGN"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/7bdf4113-6087-4eaf-ae58-1fb90117478e/app.js?nocache=1&gaTracking=G-G11NNYNY56&buttonbgcolor=2755b6&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "816-992-5225"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InY2SS9WU0VZRSs1RFJUdXBQSHVIRmc9PSIsInZhbHVlIjoiWXoyTThiOVZKb0VNb2VOTUVzcVYvZz09IiwibWFjIjoiYjkyMDEwZWE2OGUyNDAxMmQyZmZkYmNmYTBjMzAwNzg5NTE3ODE0NTIwMzRlODFmZTZiMDZlMjgwZjFiZDhmZiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701847496",
  "custom_google_gtm_id": "GTM-WSGTTQGN",
  "custom_rollout_phase": "Batch 2",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/7bdf4113-6087-4eaf-ae58-1fb90117478e/app.js?nocache=1&gaTracking=G-G11NNYNY56&buttonbgcolor=2755b6&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "816-992-5225",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InY2SS9WU0VZRSs1RFJUdXBQSHVIRmc9PSIsInZhbHVlIjoiWXoyTThiOVZKb0VNb2VOTUVzcVYvZz09IiwibWFjIjoiYjkyMDEwZWE2OGUyNDAxMmQyZmZkYmNmYTBjMzAwNzg5NTE3ODE0NTIwMzRlODFmZTZiMDZlMjgwZjFiZDhmZiJ9",
  "custom_audioeye_site_id": "65e2a3e2-eabf-4791-8930-c10486de046f",
  "custom_audioeye_site_hash": "64b824916dea5651aed784504c825594"
};

export const generatedAt = '2026-11-03T23:03:22.516Z';
